<template>
  <NuxtLayout name="activity">
    <!-- style="width: 1092px;" -->
    <div
      class="page-login w"
      :class="{ hnkjspx: hrefUrl == 'hnkdtdxlkcxx.ykumda.com' }"
    >
      <!-- CAS 中转：遮住登录表单，避免跳 IDS / 验票时闪现登录页 -->
      <div v-if="casTransit" class="cas_transit_mask">
        <div class="cas_transit_card">
          <div class="cas_transit_spinner" />
          <p class="cas_transit_text">{{ casTransitText }}</p>
        </div>
      </div>
      <div
        v-show="!casTransit"
        class="page-login-main"
      >
      <div
        class="left"
        v-if="
          hrefUrl != 'hnkdtdxlkcxx.ykumda.com' &&
          hrefUrl != 'hnkdtdxlkspx.ykumda.com' &&
          false
        "
      >
        <img src="@/assets/images/login/left_img.png" alt="" />
      </div>

      <div v-else>
        <!-- <img src="@/assets/images/login/left_imgHnkj.png" alt="" /> -->
      </div>
      <div v-if="loginPlat === 1" class="form_container" :class="{ 'admin-login-layout': isTargetDomain }">
        <!-- 针对域名新增管理员登录 -->
        <template v-if="isTargetDomain">
          <el-tabs v-model="loginType" class="outer-tabs">
            <!-- 学员登录 -->
            <el-tab-pane label="学员登录" name="student">
              <el-tabs v-model="tabName" @change="tabChange" class="inner_tabs" >
                <el-tab-pane label="账号登录" name="1">
                  <div class="pwdForm">
                    <div class="form_box">
                      <el-form
                        ref="pwdFormRef"
                        :model="pwdForm"
                        :rules="pwdRules"
                        class="demo-pwdForm"
                        size="large"
                      >
                        <client-only>
                          <el-form-item prop="phone">
                            <div class="prefix_select_input">
                              <el-input
                                v-model="pwdForm.phone"
                                placeholder="请输入手机号"
                                @keyup.enter="submitForm(pwdFormRef)"
                              >
                                <template #prefix>
                                  <span class="ellipsis">+{{ pwdForm.telCode }}</span>
                                </template>
                              </el-input>
                            </div>
                          </el-form-item>
                          <el-form-item prop="loginPwd">
                            <el-input
                              v-model="pwdForm.loginPwd"
                              type="password"
                              show-password
                              placeholder="请输入密码"
                              @keyup.enter="submitForm(pwdFormRef)"
                            >
                              <template #prefix>
                                <el-icon class="el-input__icon">
                                  <lock />
                                </el-icon>
                              </template>
                            </el-input>
                          </el-form-item>
                          <el-form-item
                            v-if="imgVerification.img"
                            prop="imageVerification"
                          >
                            <div class="img_verification">
                              <el-input
                                v-model="pwdForm.imageVerification"
                                placeholder="请输入验证码"
                                @keyup.enter="submitForm(pwdFormRef)"
                              />
                              <img
                                :src="imgVerification.img"
                                alt=""
                                @click="getImgVerification"
                              />
                            </div>
                          </el-form-item>
                        </client-only>
                      </el-form>
                      <div class="row" prop="rememberLogin">
                        <span
                          style="margin-left: 20px; z-index: 999; font-size: 14px"
                        >
                          登录或完成注册即代表你同意<span
                            class="blue_text"
                            @click="agreementModel.visible = true"
                            >《用户协议》</span
                          >
                        </span>
                        <div class="btn">
                          <NuxtLink to="/resetpwd">
                            <span class="blue">忘记密码？</span>
                          </NuxtLink>
                        </div>
                      </div>
                    </div>
                    <div class="other_login_new" v-if="showLogin && tabName !== '3'">
                      <p>第三方账号快速登录</p>
                      <div class="icon_list">
                        <img
                          src="@/assets/images/login/icon_weixin.svg"
                          alt=""
                          @click="handleChangePlat(2)"
                        />
                      </div>
                    </div>
                    <el-button
                      class="submit"
                      type="primary"
                      @keyup.enter="submitForm(pwdFormRef)"
                      @click="submitForm(pwdFormRef)"
                    >
                      登录
                    </el-button>
                    <div
                      v-if="
                        nav &&
                        nav.userRegister &&
                        store.shopData &&
                        store.shopData.config.allowUserRegister
                      "
                      class="btn register_btn"
                    >
                      <NuxtLink to="/register">
                        <span class="blue">没有账号，我要注册 ></span>
                      </NuxtLink>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="短信登录" name="2">
                  <div class="pwdForm">
                    <div class="form_box">
                      <el-form
                        ref="codeFormRef"
                        :model="pwdForm"
                        :rules="codeRules"
                        class="demo-pwdForm"
                        size="large"
                      >
                        <el-form-item prop="telCode">
                          <div class="prefix_select_input">
                            <el-input
                              v-model="pwdForm.phone"
                              placeholder="请输入手机号"
                              @keyup.enter="submitForm(codeFormRef)"
                            >
                              <template #prefix>
                                <client-only>
                                  <span class="ellipsis">+{{ pwdForm.telCode }}</span>
                                </client-only>
                              </template>
                            </el-input>
                          </div>
                        </el-form-item>
                        <el-form-item prop="verificationCode">
                          <el-input
                            v-model="pwdForm.verificationCode"
                            placeholder="短信验证码"
                            @keyup.enter="submitForm(codeFormRef)"
                          >
                            <template #prefix>
                              <span class="iconfont icon-comment" />
                            </template>
                            <template #suffix>
                              <el-button type="primary" @click="getCode">
                                {{ txt }}
                              </el-button>
                            </template>
                          </el-input>
                        </el-form-item>
                        <el-form-item
                          v-if="imgVerification.img"
                          prop="imageVerification"
                        >
                          <div class="img_verification">
                            <el-input
                              v-model="pwdForm.imageVerification"
                              placeholder="请输入验证码"
                              @keyup.enter="submitForm(codeFormRef)"
                            />
                            <img
                              :src="imgVerification.img"
                              alt=""
                              @click="getImgVerification"
                            />
                          </div>
                        </el-form-item>
                      </el-form>
                      <div class="row">
                        <span
                          style="margin-left: 20px; z-index: 999; font-size: 14px"
                        >
                          登录或完成注册即代表你同意<span
                            class="blue_text"
                            @click="agreementModel.visible = true"
                            >《用户协议》</span
                          >
                        </span>
                        <div class="btn">
                          <Nuxt-Link to="/resetpwd">
                            <span class="blue">忘记密码？</span>
                          </Nuxt-Link>
                        </div>
                      </div>
                    </div>
                    <div class="other_login_new" v-if="showLogin && tabName !== '3'">
                      <p>第三方账号快速登录</p>
                      <div class="icon_list">
                        <img
                          src="@/assets/images/login/icon_weixin.svg"
                          alt=""
                          @click="handleChangePlat(2)"
                        />
                      </div>
                    </div>
                    <el-button
                      class="submit"
                      type="primary"
                      @click="submitForm(codeFormRef)"
                    >
                      登录
                    </el-button>
                    <div
                      v-if="
                        nav &&
                        nav.userRegister &&
                        store.shopData &&
                        store.shopData.config.allowUserRegister
                      "
                      class="btn register_btn"
                    >
                      <NuxtLink to="/register">
                        <span class="blue">没有账号，我要注册 ></span>
                      </NuxtLink>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane
                  v-if="enableRealPersonLogin"
                  label="人脸验证"
                  name="3"
                >
                  <div class="pwdForm face-login-pane">
                    <div class="face-login-account">
                      <el-form size="large" class="face-login-account-form">
                        <el-form-item label="">
                          <el-input
                            v-model="faceLoginIdCard"
                            placeholder="请输入身份证号"
                            maxlength="18"
                            clearable
                          />
                        </el-form-item>
                      </el-form>
                    </div>
                    <p class="face-login-hint">
                      请输入身份证号，按提示完成刷脸即可登录。
                    </p>
                    <el-button
                      class="submit face-login-submit"
                      type="primary"
                      :loading="faceLoginLoading"
                      @click="handleLoginFaceVerify"
                    >
                      开始人脸验证
                    </el-button>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <!-- 管理员登录 -->
            <el-tab-pane label="管理员登录" name="admin">
              <el-tabs v-model="adminTabName" class="inner_tabs">
                <el-tab-pane label="密码登录" name="pwd">
                  <el-form
                    ref="adminPwdFormRef"
                    :model="adminForm"
                    :rules="adminPwdRules"
                    size="large"
                    class="admin-form"
                  >
                    <el-form-item prop="phone">
                      <el-input
                        v-model="adminForm.phone"
                        placeholder="请输入手机号"
                        maxlength="11"
                        @keyup.enter="submitAdminLogin"
                      >
                        <template #prefix>
                          <span class="ellipsis">+{{ adminForm.telCode }}</span>
                        </template>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="loginPwd">
                      <el-input
                        v-model="adminForm.loginPwd"
                        type="password"
                        show-password
                        placeholder="请输入密码"
                        @keyup.enter="submitAdminLogin"
                      />
                    </el-form-item>
                    <!-- 管理员图形验证码 -->
                    <el-form-item
                      v-if="adminImgVerification.img"
                      prop="adminImageVerification"
                    >
                      <div class="img_verification">
                        <el-input
                          v-model="adminForm.adminImageVerification"
                          placeholder="请输入验证码"
                          @keyup.enter="submitAdminLogin"
                        />
                        <img
                          :src="adminImgVerification.img"
                          alt=""
                          @click="getAdminImgVerification"
                        />
                      </div>
                    </el-form-item>
                    <el-form-item>
                      <div class="sort_btn">
                        <el-checkbox v-model="adminForm.remember">记住账号</el-checkbox>
                      </div>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        class="submit"
                        @click="submitAdminLogin"
                      >
                        登录
                      </el-button>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
                <el-tab-pane label="短信登录" name="code">
                  <el-form
                    ref="adminCodeFormRef"
                    :model="adminForm"
                    :rules="adminCodeRules"
                    size="large"
                    class="admin-form"
                  >
                    <el-form-item prop="phone">
                      <el-input
                        v-model="adminForm.phone"
                        placeholder="请输入手机号"
                        maxlength="11"
                        @keyup.enter="submitAdminLogin"
                      >
                        <template #prefix>
                          <span class="ellipsis">+{{ adminForm.telCode }}</span>
                        </template>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="verificationCode">
                      <el-input
                        v-model="adminForm.verificationCode"
                        placeholder="请输入短信验证码"
                        @keyup.enter="submitAdminLogin"
                      >
                        <template #suffix>
                          <el-button type="primary" @click="getAdminCode">
                            {{ adminTxt }}
                          </el-button>
                        </template>
                      </el-input>
                    </el-form-item>
                    <!-- 管理员图形验证码 -->
                    <el-form-item
                      v-if="adminImgVerification.img"
                      prop="adminImageVerification"
                    >
                      <div class="img_verification">
                        <el-input
                          v-model="adminForm.adminImageVerification"
                          placeholder="请输入验证码"
                          @keyup.enter="submitAdminLogin"
                        />
                        <img
                          :src="adminImgVerification.img"
                          alt=""
                          @click="getAdminImgVerification"
                        />
                      </div>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        class="submit"
                        @click="submitAdminLogin"
                      >
                        登录
                      </el-button>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </template>

        <!-- 其他域名保持原有登录逻辑不变 -->
        <template v-else>
        <!-- <img class="login_plat" src="@/assets/images/login/app.png" alt="" /> -->
        <!-- <div
          v-if="shopConfig.enableWxPcLogin"
          class="tab_wrapper"
        >
          <img
            class="tab_img pointer"
            src="@/assets/images/login/app_1.png"
            alt=""
            @click="handleChangePlat(2)"
          >
          <div class="login_tips">
            微信登录
          </div>
        </div> -->
        <div v-if="shopConfig.enableCasLogin" class="cas_login_box">
          <p v-if="casNeedAuthTip" class="cas_login_tip">
            请先完成学校统一身份认证登录。若您尚未在统一认证平台登录，将进入学校登录页；已登录则可自动进入统考英语。
          </p>
          <el-button
            class="cas_login_btn"
            type="primary"
            :loading="casLoginLoading"
            @click="retryCasLogin"
          >
            学校统一身份认证登录
          </el-button>
          <div class="cas_login_split">或使用账号登录</div>
        </div>
        <el-dialog
          v-model="casRoleDialog.visible"
          title="请选择进入身份"
          width="420px"
          :close-on-click-modal="false"
          append-to-body
        >
          <p style="margin-bottom: 16px; color: #606266">
            检测到您同时具备学员与管理员身份，请选择进入：
          </p>
          <div class="cas_role_actions">
            <el-button
              type="primary"
              style="width: 100%; margin-bottom: 12px"
              @click="enterCasStudent"
            >
              进入学员端
            </el-button>
            <el-button
              style="width: 100%; margin-left: 0"
              @click="enterCasAdmin"
            >
              进入管理端
            </el-button>
          </div>
        </el-dialog>
        <el-tabs v-model="tabName" @change="tabChange">
          <el-tab-pane label="账号登录" name="1">
            <div class="pwdForm">
              <div class="form_box">
                <el-form
                  ref="pwdFormRef"
                  :model="pwdForm"
                  :rules="pwdRules"
                  class="demo-pwdForm"
                  size="large"
                >
                  <client-only>
                    <el-form-item prop="phone">
                      <div class="prefix_select_input">
                        <el-input
                          v-model="pwdForm.phone"
                          placeholder="请输入手机号或身份证号"
                          maxlength="18"
                          clearable
                          @keyup.enter="submitForm(pwdFormRef)"
                        >
                          <template #prefix>
                            <el-icon
                              v-if="pwdAccountShowIdCardPrefix"
                              class="el-input__icon"
                            >
                              <User />
                            </el-icon>
                            <span v-else class="ellipsis">+{{ pwdForm.telCode }}</span>
                          </template>
                        </el-input>
                      </div>
                    </el-form-item>
                    <el-form-item prop="loginPwd">
                      <el-input
                        v-model="pwdForm.loginPwd"
                        type="password"
                        show-password
                        placeholder="请输入密码"
                        @keyup.enter="submitForm(pwdFormRef)"
                      >
                        <template #prefix>
                          <el-icon class="el-input__icon">
                            <lock />
                          </el-icon>
                        </template>
                      </el-input>
                    </el-form-item>
                    <el-form-item
                      v-if="imgVerification.img"
                      prop="imageVerification"
                    >
                      <div class="img_verification">
                        <el-input
                          v-model="pwdForm.imageVerification"
                          placeholder="请输入验证码"
                          @keyup.enter="submitForm(pwdFormRef)"
                        />
                        <img
                          :src="imgVerification.img"
                          alt=""
                          @click="getImgVerification"
                        />
                      </div>
                    </el-form-item>
                  </client-only>
                </el-form>
                <div class="row" prop="rememberLogin">
                  <span
                    style="margin-left: 20px; z-index: 999; font-size: 14px"
                  >
                    登录或完成注册即代表你同意<span
                      class="blue_text"
                      @click="agreementModel.visible = true"
                      >《用户协议》</span
                    >
                  </span>
                  <!-- <el-checkbox
                    style="margin-left: 20px; z-index: 999"
                    v-model="pwdForm.isAgreement"
                    size="default"
                  >
                    我已阅读并同意<span
                      class="blue_text"
                      @click="agreementModel.visible = true"
                      >《用户协议》</span
                    >
                  </el-checkbox> -->
                  <div class="btn">
                    <NuxtLink to="/resetpwd">
                      <span class="blue">忘记密码？</span>
                    </NuxtLink>
                  </div>
                </div>
              </div>
              <div class="other_login" v-if="showLogin && tabName !== '3'">
                <p>第三方账号快速登录</p>
                <div class="icon_list">
                  <img
                    src="@/assets/images/login/icon_weixin.svg"
                    alt=""
                    @click="handleChangePlat(2)"
                  />
                  <!-- <img src="@/assets/images/login/icon_qq.png" alt="" @click="handleChangeQQ"/> -->
                  <!-- <a href="{$openLoginUrl.connectQQ}" class="icon connect-qq"><span icon-bg2="icon_qq_n"></span>  QQ登录</a>  -->
                  <!-- <svg class="icondx" @click="qqlogin"  aria-hidden="true">
                    <use   xlink:href="#icon-QQ1"></use>
                  </svg> -->
                </div>
                <!-- <div class="icon_list" >
                  <img
                    v-for="(item, index) in loginIconList"
                    :src="item.icon"
                    :key="index"
                    alt=""
                  />
                </div> -->
              </div>
              <el-button
                class="submit"
                type="primary"
                @keyup.enter="submitForm(pwdFormRef)"
                @click="submitForm(pwdFormRef)"
              >
                登录
              </el-button>
              <div
                v-if="
                  nav &&
                  nav.userRegister &&
                  store.shopData &&
                  store.shopData.config.allowUserRegister
                "
                class="btn register_btn"
              >
                <NuxtLink to="/register">
                  <span class="blue">没有账号，我要注册 ></span>
                </NuxtLink>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="短信登录" name="2">
            <div class="pwdForm">
              <div class="form_box">
                <el-form
                  ref="codeFormRef"
                  :model="pwdForm"
                  :rules="codeRules"
                  class="demo-pwdForm"
                  size="large"
                >
                  <el-form-item prop="telCode">
                    <div class="prefix_select_input">
                      <el-input
                        v-model="pwdForm.phone"
                        placeholder="请输入手机号"
                        @keyup.enter="submitForm(codeFormRef)"
                      >
                        <template #prefix>
                          <client-only>
                            <span class="ellipsis">+{{ pwdForm.telCode }}</span>
                            <!-- <span
                              class="c_333 pointer pop_holder"
                              @click="openPopver"
                            >

                              <i class="arrows-bottom" />
                            </span> -->
                            <!-- <el-popover
                              ref="choosePop2"
                              placement="bottom-start"
                              :width="380"
                              trigger="click"
                              :teleported="true"
                            >
                              <template #reference>
                                <span
                                  class="c_333 pointer pop_holder"
                                  @click="openPopver"
                                >
                                  <span class="ellipsis"
                                    >+{{ pwdForm.telCode }}</span
                                  >
                                  <i class="arrows-bottom" />
                                </span>
                              </template>
                              <el-scrollbar>
                                <div class="te_code_enum">
                                  <div
                                    v-for="item in opts.TelCodeEnum"
                                    :key="item.standardDesc"
                                    class="te_code_enum_item"
                                    @click="handleSelectTelCode(item)"
                                  >
                                    <span>
                                      <span class="mgr10">
                                        {{ item.codeDesc }}</span
                                      >
                                      <span>{{ item.standardDesc }}</span>
                                    </span>
                                    <i
                                      v-if="
                                        item.code + item.standardDesc ===
                                        pwdForm.telCode + opts.country
                                      "
                                      class="iconfont icon-correct blue font12"
                                    />
                                  </div>
                                </div>
                              </el-scrollbar>
                            </el-popover> -->
                          </client-only>
                        </template>
                      </el-input>
                    </div>
                  </el-form-item>
                  <el-form-item prop="verificationCode">
                    <el-input
                      v-model="pwdForm.verificationCode"
                      placeholder="短信验证码"
                      @keyup.enter="submitForm(codeFormRef)"
                    >
                      <template #prefix>
                        <span class="iconfont icon-comment" />
                      </template>
                      <template #suffix>
                        <el-button type="primary" @click="getCode">
                          {{ txt }}
                        </el-button>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="imgVerification.img"
                    prop="imageVerification"
                  >
                    <div class="img_verification">
                      <el-input
                        v-model="pwdForm.imageVerification"
                        placeholder="请输入验证码"
                        @keyup.enter="submitForm(codeFormRef)"
                      />
                      <img
                        :src="imgVerification.img"
                        alt=""
                        @click="getImgVerification"
                      />
                    </div>
                  </el-form-item>
                </el-form>
                <div class="row">
                  <span
                    style="margin-left: 20px; z-index: 999; font-size: 14px"
                  >
                    登录或完成注册即代表你同意<span
                      class="blue_text"
                      @click="agreementModel.visible = true"
                      >《用户协议》</span
                    >
                  </span>
                  <!-- <el-checkbox
                    style="margin-left: 20px; z-index: 999"
                    v-model="pwdForm.isAgreement"
                    size="default"
                  >

                  </el-checkbox> -->
                  <div class="btn">
                    <Nuxt-Link to="/resetpwd">
                      <span class="blue">忘记密码？</span>
                    </Nuxt-Link>
                  </div>
                </div>
              </div>
              <div class="other_login" v-if="showLogin && tabName !== '3'">
                <p>第三方账号快速登录</p>
                <div class="icon_list">
                  <img
                    src="@/assets/images/login/icon_weixin.svg"
                    alt=""
                    @click="handleChangePlat(2)"
                  />
                  <!-- <img src="@/assets/images/login/icon_qq.png" alt="" @click="handleChangeQQ"/> -->
                  <!-- <a href="{$openLoginUrl.connectQQ}" class="icon connect-qq"><span icon-bg2="icon_qq_n"></span>  QQ登录</a>  -->
                  <!-- <svg class="icondx" @click="qqlogin"  aria-hidden="true">
                    <use   xlink:href="#icon-QQ1"></use>
                  </svg> -->
                </div>
                <!-- <div class="icon_list" >
                  <img
                    v-for="(item, index) in loginIconList"
                    :src="item.icon"
                    :key="index"
                    alt=""
                  />
                </div> -->
              </div>
              <el-button
                class="submit"
                type="primary"
                @click="submitForm(codeFormRef)"
              >
                登录
              </el-button>
              <div
                v-if="
                  nav &&
                  nav.userRegister &&
                  store.shopData &&
                  store.shopData.config.allowUserRegister
                "
                class="btn register_btn"
              >
                <NuxtLink to="/register">
                  <span class="blue">没有账号，我要注册 ></span>
                </NuxtLink>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="enableRealPersonLogin"
            label="人脸验证"
            name="3"
          >
            <div class="pwdForm face-login-pane">
              <div class="face-login-account">
                <el-form size="large" class="face-login-account-form">
                  <el-form-item label="">
                    <el-input
                      v-model="faceLoginIdCard"
                      placeholder="请输入身份证号"
                      maxlength="18"
                      clearable
                    />
                  </el-form-item>
                </el-form>
              </div>
              <p class="face-login-hint">
                请输入身份证号，按提示完成刷脸即可登录。
              </p>
              <el-button
                class="submit face-login-submit"
                type="primary"
                :loading="faceLoginLoading"
                @click="handleLoginFaceVerify"
              >
                开始人脸验证
              </el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
        </template>
      </div>
      <div v-if="loginPlat === 2" class="form_container">
        <!-- <img class="login_plat" src="@/assets/images/login/pc.png" alt="" /> -->
        <div class="tab_wrapper">
          <img
            class="tab_img pointer"
            src="@/assets/images/login/pc_1.png"
            alt=""
            @click="handleChangePlat(1)"
          />
          <div class="login_tips">账号登录</div>
        </div>
        <div v-if="!bindingWxModel.visible" class="drcode">
          <iframe
            v-if="wxLoginUrl"
            class="qr_code_iframe"
            :src="wxLoginUrl"
            frameborder="0"
          />
          <!-- <qrcode class="qr_code" v-if="wxLoginUrl" :value="wxLoginUrl" :size="200" alt="微信扫码登录" /> -->
          <div class="desc">
            <p>微信登录成功即代表同意《用户协议》</p>
          </div>
        </div>
        <binding-wx
          v-model="bindingWxModel.visible"
          :user-info="bindingWxModel.userInfo"
          :title="bindingWxModel.title"
          @callback="hanldeClosebindingWxModel"
        />
        <!-- <div class="other_login">
          <p>其他登录方式</p>
          <div class="icon_list">
            <img
              v-for="(item, index) in loginIconList"
              :src="item.icon"
              alt=""
              :key="index"
            />
          </div>
        </div> -->
      </div>
      <client-only>
        <agreement v-model="agreementModel.visible" />
      </client-only>
      </div>
    </div>
    <client-only>
      <!-- 阿里云验证码弹框 -->
      <AliyunCaptchaDialog
        v-model="captchaVisible"
        :captcha-id="captchaConfig.captchaId"
        @success="handleCaptchaSuccess"
        @error="handleCaptchaError"
        @close="handleCaptchaClose"
      />
    </client-only>
    <el-dialog
      v-model="faceQrDialogVisible"
      title="请扫码完成人脸验证"
      width="460px"
      center
      close-on-click-modal="false"
    >
      <div style="text-align: center; padding: 20px 0">
        <img
          v-if="faceQrBase64"
          :src="faceQrBase64"
          alt="人脸验证二维码"
          style="width: 280px; height: 280px; object-fit: contain"
        />
        <div v-else style="color: #999">加载中...</div>
        <div style="margin-top: 15px; font-size: 14px; color: #666">
          请使用微信完成活体人脸认证
        </div>
      </div>
    </el-dialog>

    <!-- 实人认证弹窗 -->
    <el-dialog
      v-model="realPersonDialogVisible"
      :title="realPersonDialogTitle"
      :width="!isLiveness && realPersonStep === 'upload' ? '720px' : '520px'"
      center
      :close-on-click-modal="false"
      class="realperson-dialog"
      @close="handleRealPersonDialogClose"
    >
      <div class="realperson-dialog-content">
        <!-- 首次认证：身份证正反面上传 -->
        <div v-if="!isLiveness && realPersonStep === 'upload'" class="idcard-upload-wrapper">
          <p class="upload-lead">请上传本人有效身份证人像面与国徽面照片</p>
          <div class="upload-row">
            <div class="upload-section">
              <div class="upload-tip">
                <span class="upload-step">1</span>
                人像面
              </div>
              <el-upload
                class="idcard-uploader"
                :class="{ 'is-ready': idCardFrontReady }"
                action="#"
                :show-file-list="false"
                :before-upload="beforeIdCardUpload"
                :http-request="(opt) => handleIdCardUpload(opt, 'face')"
                accept="image/*"
              >
                <img
                  v-if="idCardFrontImageUrl"
                  :src="idCardFrontImageUrl"
                  class="idcard-preview"
                />
                <div v-else class="upload-placeholder">
                  <el-icon class="upload-plus"><Plus /></el-icon>
                  <span>选择人像面照片</span>
                </div>
              </el-upload>
            </div>

            <div class="upload-section">
              <div class="upload-tip">
                <span class="upload-step">2</span>
                国徽面
              </div>
              <el-upload
                class="idcard-uploader"
                :class="{ 'is-ready': idCardBackReady }"
                action="#"
                :show-file-list="false"
                :before-upload="beforeIdCardUpload"
                :http-request="(opt) => handleIdCardUpload(opt, 'back')"
                accept="image/*"
              >
                <img
                  v-if="idCardBackImageUrl"
                  :src="idCardBackImageUrl"
                  class="idcard-preview"
                />
                <div v-else class="upload-placeholder">
                  <el-icon class="upload-plus"><Plus /></el-icon>
                  <span>选择国徽面照片</span>
                </div>
              </el-upload>
            </div>
          </div>

          <div v-if="idCardOcrLoading" class="ocr-loading">
            <el-icon class="is-loading" /><span>正在识别...</span>
          </div>

          <!-- OCR 结果确认界面 -->
          <div v-if="idCardOcrResult" class="ocr-confirm-section">
            <div class="ocr-confirm-title">请确认识别信息</div>
            <div class="ocr-form">
              <div class="form-item">
                <label>姓名</label>
                <el-input v-model="idCardOcrResult.name" placeholder="请输入姓名" clearable />
              </div>
              <div class="form-item">
                <label>身份证号</label>
                <el-input v-model="idCardOcrResult.idNumber" placeholder="请输入身份证号" clearable />
              </div>
              <div class="form-item form-item--half">
                <label>有效期起</label>
                <el-input v-model="idCardOcrResult.startDate" placeholder="上传国徽面后自动识别" readonly />
              </div>
              <div class="form-item form-item--half">
                <label>有效期止</label>
                <el-input v-model="idCardOcrResult.endDate" placeholder="上传国徽面后自动识别" readonly />
              </div>
            </div>
            <div class="ocr-confirm-tip">姓名/证件号如识别有误可手动修改；有效期仅支持重新上传国徽面识别</div>
            <div class="ocr-confirm-actions">
              <el-button size="large" @click="resetOcrResult">重新上传</el-button>
              <el-button
                type="primary"
                size="large"
                :disabled="!idCardFrontImageUrl || !idCardBackImageUrl"
                @click="startRealPersonVerifyWithOcr"
              >
                确认并开始验证
              </el-button>
            </div>
          </div>
        </div>

        <!-- 后续登录有底图：本机自拍 VIAPI（与课中一致） -->
        <div v-else-if="loginViapiMode" class="login-viapi-wrap">
          <p class="qr-tip">{{ realPersonTipText }}</p>
          <!-- 无摄像头 / 打开失败：引导去手机端 -->
          <div v-if="loginViapiCamError" class="login-viapi-no-cam">
            <p class="login-viapi-no-cam-title">{{ loginViapiCamError }}</p>
            <ul class="login-viapi-no-cam-list">
              <li>建议使用<strong>手机浏览器</strong>打开本平台登录，并在手机端观看课程</li>
              <li>手机自带前置摄像头，刷脸验证更稳定</li>
              <li>若仍用电脑：请换 Chrome / Edge，允许摄像头权限，并确认设备已接入摄像头</li>
              <li>非 HTTPS（或 localhost）环境下浏览器可能禁止调用摄像头</li>
            </ul>
            <div class="login-viapi-actions">
              <el-button
                type="primary"
                size="large"
                :loading="loginViapiOpening"
                @click="openLoginViapiCamera"
              >
                重新检测摄像头
              </el-button>
            </div>
          </div>
          <div v-else-if="!loginViapiPreview" class="login-viapi-cam">
            <video
              ref="loginViapiVideoRef"
              class="login-viapi-video"
              autoplay
              muted
              playsinline
            />
            <div class="login-viapi-actions">
              <el-button
                v-if="!loginViapiReady"
                type="primary"
                size="large"
                :loading="loginViapiOpening"
                @click="openLoginViapiCamera"
              >
                {{ loginViapiOpening ? '正在打开摄像头...' : '打开摄像头' }}
              </el-button>
              <el-button
                v-else
                type="primary"
                size="large"
                @click="captureLoginViapiShot"
              >
                点击拍照
              </el-button>
            </div>
            <p class="login-viapi-soft-tip">
              若本机无摄像头，建议使用手机端登录并观看课程
            </p>
          </div>
          <div v-else class="login-viapi-preview">
            <img :src="loginViapiPreview" class="login-viapi-img" alt="预览" />
            <div class="login-viapi-actions">
              <el-button size="large" @click="retakeLoginViapiShot">重新拍照</el-button>
              <el-button
                type="primary"
                size="large"
                :loading="loginViapiSubmitting"
                @click="submitLoginViapiShot"
              >
                上传验证
              </el-button>
            </div>
          </div>
          <div v-if="realPersonStatus === 'success'" class="verify-status verify-success">
            <el-icon><CircleCheck /></el-icon><span>验证通过！正在跳转...</span>
          </div>
          <div v-if="realPersonStatus === 'fail'" class="verify-status verify-fail">
            <div class="fail-main">
              <el-icon class="fail-icon"><CircleClose /></el-icon>
              <span class="fail-text">{{ realPersonFailMsg || "认证失败，请重试" }}</span>
            </div>
            <div class="fail-actions">
              <el-button type="primary" @click="retakeLoginViapiShot">重新拍照</el-button>
            </div>
          </div>
        </div>

        <!-- 首次实人 / 缺底图降级：二维码扫码 -->
        <div v-else class="qr-code-wrapper">
          <qrcode-vue
            v-if="realPersonCertifyUrl && !realPersonQrExpired"
            :value="realPersonCertifyUrl"
            :size="240"
            level="H"
          />
          <div v-else-if="!realPersonQrExpired" class="qr-loading">二维码生成中...</div>
          <div v-if="realPersonQrExpired" class="qr-expired-mask">
            <p>二维码已过期</p>
            <el-button type="primary" @click="refreshRealPersonQr">刷新二维码</el-button>
          </div>
        </div>
        <p v-if="!loginViapiMode" class="qr-tip">{{ realPersonTipText }}</p>
        <!-- 认证状态 -->
        <div v-if="!loginViapiMode && realPersonStatus === 'pending'" class="verify-status verify-pending">
          <el-icon class="is-loading" /><span>等待验证中...</span>
        </div>
        <div v-if="!loginViapiMode && realPersonStatus === 'success'" class="verify-status verify-success">
          <el-icon><CircleCheck /></el-icon><span>验证通过！正在跳转...</span>
        </div>
        <div v-if="!loginViapiMode && realPersonStatus === 'fail'" class="verify-status verify-fail">
          <div class="fail-main">
            <el-icon class="fail-icon"><CircleClose /></el-icon>
            <span class="fail-text">{{ realPersonFailMsg || "认证失败，请重试" }}</span>
          </div>
          <div class="fail-actions">
            <el-button
              v-if="realPersonRetryAction === 'reupload_id'"
              type="primary"
              @click="goReuploadIdCard"
            >
              核对身份证信息
            </el-button>
            <el-button v-else type="primary" @click="refreshRealPersonQr">
              重新扫脸认证
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </NuxtLayout>
</template>
<script setup>
import login_wx from "../../assets/images/login/icon_wx.png";
import login_qq from "../../assets/images/login/icon_qq.png";
import { ElMessage } from "element-plus";
import { Lock, CircleCheck, CircleClose, Plus, User } from "@element-plus/icons-vue";
import { useUserStore } from "@/stores/user";
import { useNavStore } from "@/stores/nav";
import {
  getMsg,
  userLoginPwd,
  userLoginIdCardPwd,
  userLoginCode,
  getImageVerification,
  getAppKeyInfo,
  verificationCaptch,
  realPersonInit,
  realPersonQuery,
  realPersonInitLiveness,
  realPersonQueryLiveness,
  realPersonViapiVerify,
  realPersonLoginCheck,
  realPersonLoginComplete,
  ocrIdCard,
  realPersonStoredIdInfo,
} from "@/api/user";
import { setSession, getStore, setStore, getSession } from "@/utils/storage";
import { getWxAuthLoginUrl, wxLogin, getCasLoginUrl, casLogin, shopDataInfo } from "@/api/system";
import bindingWx from "@/components/login/bindingWx.vue";
import AliyunCaptchaDialog from "@/components/login/AliyunCaptchaDialog.vue";
import config from "@/config";
import cookie from "@/utils/cookies";
import {
  CAS_AUTO_REDIRECT_KEY,
  CAS_SERVICE_KEY,
  buildCasLoginService,
  casSessionGet,
  casSessionRemove,
  casSessionSet,
  clearCasGuestBrowse,
  clearCasTransitPending,
  isCasLoginEnabled,
  isCasTransitPending,
} from "@/utils/casSso";
import { getMetaInfoSoft } from "@/utils/aliyunLoginFace.js";
import { isValidIdCardNumber, validateIdCardValidPeriod, validateIdCardValidPeriodRecognized } from "@/utils/idCardValidPeriod.js";
import JSEncrypt from "jsencrypt";
import QrcodeVue from "qrcode.vue";
import Cookies from 'js-cookie'
import {
  adminLoginPwd,
  adminLoginCode,
  adminSendCode,
  adminChooseEnterprise,
  adminGetUserEnterpriseList,
  getCodeImg,
} from '@/api/admin'

const { data: shopData } = await useAsyncData("course", async (ctx) => {
  let url = "";
  if (process.server) {
    url = ctx.ssrContext?.event?.req?.headers?.host;
  } else {
    url = window.location.host;
  }
  if (config.url) {
    url = config.url;
  }
  return await shopDataInfo({ domain: url });
});

const cookieData = cookie.getShop();
const hrefUrl = ref("");

useHead({
  title: "登录中心-" + cookieData.shopName,
});
const isContract = ref(false);
const store = useUserStore();
const navStore = useNavStore();
const nav = navStore.nav;
const { getEnumList, setToken, removeToken, getUserView, getShopInfo } = store;
const router = useRouter();
const route = useRoute();
const purchaseSwitch = computed(() => {
  try {
    const shopDataCache = getSession("shopInfo")
      ? JSON.parse(getSession("shopInfo"))
      : null;
    const shopId =
      shopDataCache?.id ??
      shopData?.value?.id ??
      (process.client ? cookie.getInClient("shopId") : null);
    if (shopId === "1686181461997211650") {
      return false;
    }
    return (
      shopDataCache?.config?.purchaseSwitch ??
      shopData?.value?.config?.purchaseSwitch ??
      false
    );
  } catch (e) {
    const shopId =
      shopData?.value?.id ??
      (process.client ? cookie.getInClient("shopId") : null);
    if (shopId === "1686181461997211650") {
      return false;
    }
    return shopData?.value?.config?.purchaseSwitch ?? false;
  }
});
const agreementModel = reactive({
  visible: false,
});
const loginPlat = ref(1);
const tabName = ref("1");

// 判断域名
const isTargetDomain = ref(false)
if (process.server) {
  try {
    const event = useRequestEvent()
    const host = event?.req?.headers?.host?.split(':')[0] || ''
    isTargetDomain.value = [
      'edu.shanxiyixue.com',
      'edu-test.ykumda.com',
      '192.168.10.61',
    ].includes(host)
  } catch (e) {}
}
onMounted(() => {
  const host = window.location.hostname
  isTargetDomain.value = [
    'edu.shanxiyixue.com',
    'edu-test.ykumda.com',
    '192.168.10.61',
  ].includes(host)

  // 管理员登录：回填记住的账号
  const savedAccount = localStorage.getItem("accountName")
  if (savedAccount) {
    adminForm.phone = savedAccount
    adminForm.remember = true
  }
})
// student | admin
const loginType = ref("student")
// pwd | code
const adminTabName = ref("pwd")

const adminForm = reactive({
  telCode: "86",
  phone: "",
  loginPwd: "",
  verificationCode: "",
  adminImageVerification: "",
  remember: false
})

const adminPwdFormRef = ref(null)
const adminCodeFormRef = ref(null)

const adminPwdRules = reactive({
  phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
  adminImageVerification: [
    { required: true, message: "请输入图形验证码", trigger: "blur" }
  ],
  loginPwd: [{ required: true, message: "请输入密码", trigger: "blur" }]
})

const adminImgVerification = reactive({
  img: "",
  token: ""
})

const adminCodeRules = reactive({
  phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
  verificationCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
  adminImageVerification: [    // ← 新增
    { required: true, message: "请输入图形验证码", trigger: "blur" }
  ],
})

const adminTxt = ref("获取验证码")
const adminDisabled = ref(false)

const tabChange = (type) => {
  if (type === "1") {
  } else {
  }
};
const errorNum = ref(0); // 记录登录错误次数，超过两次须填写图形验证码校验
const adminErrorNum = ref(0); // 记录管理端登录错误次数，超过两次须填写图形验证码校验
const opts = reactive({
  TelCodeEnum: "",
  country: "中国",
});
let ipInfo = reactive({});
const wxLoginUrl = ref("");
const casLoginLoading = ref(false);
const casNeedAuthTip = ref(false);
const casRoleDialog = reactive({
  visible: false,
  payload: null,
});

/** 是否允许停留在本地账号登录页（应急：/login?localLogin=1） */
const allowLocalLoginPage = () => {
  const q = route.query.localLogin;
  return q === "1" || q === "true";
};

/** 尽早判断是否走 CAS 中转（避免首屏先画出登录表单）；禁止按主机名猜测 */
const peekCasTransitNeeded = () => {
  if (allowLocalLoginPage()) {
    return false;
  }
  if (route.query.ticket) {
    return true;
  }
  if (isCasTransitPending()) {
    return true;
  }
  try {
    const raw = getSession("shopInfo");
    if (raw) {
      const shop = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (isCasLoginEnabled(shop?.config)) {
        return true;
      }
    }
  } catch (e) {}
  return false;
};

const casTransit = ref(peekCasTransitNeeded());
const casTransitText = ref(
  route.query.ticket
    ? "正在登录，请稍候…"
    : "正在前往学校统一身份认证…"
);

const showCasTransit = (text) => {
  casTransit.value = true;
  if (text) {
    casTransitText.value = text;
  }
};

const hideCasTransit = () => {
  casTransit.value = false;
  clearCasTransitPending();
};
const normalizeCasService = (raw) => {
  try {
    const u = new URL(raw);
    let path = u.pathname || "/";
    if (path.length > 1 && path.endsWith("/")) {
      path = path.slice(0, -1);
    }
    return `${u.protocol}//${u.host}${path}`;
  } catch (e) {
    return String(raw || "").split("?")[0].split("#")[0];
  }
};

const buildCasService = () => {
  return buildCasLoginService(window.location.origin);
};

const rememberCasService = (service) => {
  casSessionSet(CAS_SERVICE_KEY, service);
};

const restoreCasService = () => {
  const cached = casSessionGet(CAS_SERVICE_KEY);
  if (cached) {
    return normalizeCasService(cached);
  }
  return buildCasService();
};

const clearCasServiceCache = () => {
  casSessionRemove(CAS_SERVICE_KEY);
};

const markCasAutoRedirected = () => {
  casSessionSet(CAS_AUTO_REDIRECT_KEY, "1");
};

const clearCasAutoRedirected = () => {
  casSessionRemove(CAS_AUTO_REDIRECT_KEY);
};

const hasCasAutoRedirected = () => {
  return casSessionGet(CAS_AUTO_REDIRECT_KEY) === "1";
};

const handleCasLogin = () => {
  casNeedAuthTip.value = false;
  clearCasGuestBrowse();
  showCasTransit("正在前往学校统一身份认证…");
  const service = buildCasService();
  rememberCasService(service);
  casLoginLoading.value = true;
  getCasLoginUrl({ service })
    .then((url) => {
      if (url) {
        window.location.href = url;
        return;
      }
      clearCasAutoRedirected();
      hideCasTransit();
      casNeedAuthTip.value = true;
      ElMessage.error("获取统一身份认证地址失败，请稍后重试");
    })
    .catch(() => {
      clearCasAutoRedirected();
      hideCasTransit();
      casNeedAuthTip.value = true;
      ElMessage.error("获取统一身份认证地址失败，请稍后重试");
    })
    .finally(() => {
      casLoginLoading.value = false;
    });
};

/** 自动跳转被拦截后，手动再点：清自动标记并重新跳转 */
const retryCasLogin = () => {
  clearCasAutoRedirected();
  handleCasLogin();
};

/**
 * 店铺开启 CAS 时：访问 /login 或点首页「登录」进入本页后，自动跳西电统一认证。
 * IDS 已登录时会直接带回 ticket，再进入学员端；未登录则出现学校登录页。
 */
const tryAutoCasRedirect = () => {
  const enabled =
    shopConfig.value?.enableCasLogin === true ||
    shopConfig.value?.enableCasLogin === 1;
  if (!enabled) {
    hideCasTransit();
    return;
  }
  if (route.query.ticket || allowLocalLoginPage()) {
    if (allowLocalLoginPage()) {
      hideCasTransit();
    }
    return;
  }
  if (casRoleDialog.visible || casLoginLoading.value) {
    return;
  }
  // 已有本平台学员 token：直接进学习页，不必再走 IDS
  const existToken = store.getToken && store.getToken();
  if (existToken) {
    showCasTransit("正在进入统考英语…");
    let redirect = "/";
    if (route.query.redirect) {
      const raw = String(route.query.redirect);
      try {
        redirect = decodeURIComponent(raw);
      } catch (e) {
        redirect = raw;
      }
    }
    // vue-router 可能已解码；统一成站内 path
    if (!redirect.startsWith("/")) {
      redirect = "/";
    }
    router.replace(redirect);
    return;
  }
  // 避免从 IDS 返回/取消后死循环；提示需完成统一认证
  if (hasCasAutoRedirected()) {
    hideCasTransit();
    casNeedAuthTip.value = true;
    return;
  }
  markCasAutoRedirected();
  handleCasLogin();
};

const resolveAdminBaseUrl = () => {
  const adminHost = window.location.hostname;
  if (adminHost === "192.168.10.61") {
    return "http://192.168.10.61:9527";
  }
  if (adminHost === "edu.shanxiyixue.com") {
    return "https://edu.shanxiyixue.com";
  }
  if (adminHost === "edu-test.ykumda.com") {
    return "https://edu-test.ykumda.com";
  }
  if (adminHost.endsWith("xidian.edu.cn")) {
    return window.location.origin;
  }
  return window.location.origin;
};

const clearCasTicketQuery = () => {
  if (route.query.ticket) {
    const query = { ...route.query };
    delete query.ticket;
    router.replace({ path: route.path, query });
  }
};

const enterCasStudent = async () => {
  const res = casRoleDialog.payload;
  casRoleDialog.visible = false;
  showCasTransit("正在进入统考英语…");
  clearCasServiceCache();
  clearCasAutoRedirected();
  clearCasGuestBrowse();
  if (!res?.token) {
    hideCasTransit();
    ElMessage.error("未获取到学员登录凭证");
    return;
  }
  setToken(res.token);
  const userInfo = await getUserView();
  const redirect = route.query.redirect
    ? decodeURIComponent(String(route.query.redirect))
    : "/";
  if (userInfo && redirect.startsWith("/")) {
    router.replace({ path: redirect });
  } else {
    router.replace({ path: "/" });
  }
};

const enterCasAdmin = async () => {
  const res = casRoleDialog.payload;
  casRoleDialog.visible = false;
  showCasTransit("正在进入管理端…");
  clearCasServiceCache();
  clearCasAutoRedirected();
  clearCasGuestBrowse();
  if (!res?.adminToken) {
    hideCasTransit();
    ElMessage.error("未获取到管理端登录凭证");
    return;
  }
  await handleCasAdminLoginSuccess(res);
};

/** CAS 管理端：优先选择当前店铺，确保初始化菜单权限 */
const handleCasAdminLoginSuccess = async (res) => {
  const adminBaseUrl = resolveAdminBaseUrl();
  Cookies.set("EDU_ADMIN_TOKEN", res.adminToken, { expires: 1 });
  store.removeToken();
  setSession("userInfo", "");
  setSession("shopInfo", "");
  clearCasGuestBrowse();

  const os = getOsInfo();
  const browser = getBrowserInfo();
  const choosePayload = {
    os: os.name,
    osVersion: os.version,
    browser: browser.name,
    browserVersion: browser.version,
  };

  try {
    if (res.sid) {
      const shopRes = await adminChooseEnterprise({
        ...choosePayload,
        sid: res.sid,
      });
      localStorage.setItem("shopManager", JSON.stringify(shopRes));
      Cookies.set("EDU_ADMIN_SHOP", JSON.stringify(shopRes), { expires: 1 });
      window.location.href = adminBaseUrl + "/admin/dashboard/index";
      return;
    }
  } catch (err) {
    console.error("CAS自动选择当前店铺失败，回退企业列表", err);
  }

  await handleAdminLoginSuccess({ token: res.adminToken, managerId: res.managerId });
};

const handleCasTicketLogin = async (ticket) => {
  showCasTransit("正在登录，请稍候…");
  const service = restoreCasService();
  const data = {
    ticket: String(ticket),
    service,
    clientType: 1,
  };
  const { name: osName, version: osVersion } = getOsInfo();
  const { name: browserName, version: browserVersion } = getBrowserInfo();
  data.os = osName;
  data.osVersion = osVersion;
  data.browser = browserName;
  data.browserVersion = browserVersion;
  casLoginLoading.value = true;
  try {
    const res = await casLogin(data);
    if (!res) {
      hideCasTransit();
      casNeedAuthTip.value = true;
      return;
    }
    if (res.redirectType === "CHOOSE") {
      hideCasTransit();
      casRoleDialog.payload = res;
      casRoleDialog.visible = true;
      clearCasAutoRedirected();
      clearCasTicketQuery();
      return;
    }
    if (res.redirectType === "ADMIN" && res.adminToken) {
      showCasTransit("正在进入管理端…");
      clearCasTicketQuery();
      clearCasServiceCache();
      clearCasAutoRedirected();
      await handleCasAdminLoginSuccess(res);
      return;
    }
    if (res.token) {
      showCasTransit("正在进入统考英语…");
      clearCasServiceCache();
      clearCasAutoRedirected();
      clearCasGuestBrowse();
      setToken(res.token);
      const userInfo = await getUserView();
      let redirect = "/";
      if (route.query.redirect) {
        const raw = String(route.query.redirect);
        try {
          redirect = decodeURIComponent(raw);
        } catch (e) {
          redirect = raw;
        }
      }
      if (userInfo && redirect.startsWith("/")) {
        router.replace(redirect);
      } else {
        router.replace({ path: "/" });
      }
      return;
    }
    hideCasTransit();
    casNeedAuthTip.value = true;
    ElMessage.error("统一身份认证登录失败，未返回可用凭证");
  } catch (e) {
    console.error("CAS登录失败", e);
    hideCasTransit();
    casNeedAuthTip.value = true;
  } finally {
    casLoginLoading.value = false;
  }
  clearCasTicketQuery();
};

const handleChangePlat = (type) => {
  const redirectUrl = config.url
    ? window.location.protocol + "//" + config.url
    : window.location.href;
  loginPlat.value = type;
  if (type === 2) {
    getWxAuthLoginUrl({ redirectUrl, authType: 1 }).then((res) => {
      if (res) {
        wxLoginUrl.value = res;
      }
    });
  }
};
const handleChangeQQ = () => {
  location.href =
    "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102024981&redirect_uri=http://huchunlin.cn/loginserver/wxlogin&state=Vr12qQmurwoRYeV7";
  // location.href="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102068985&redirect_uri=https://edu.shanxiyixue.com/mycb&state=rmBNL4ZpqeDXdU7W"
  // https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102068985&redirect_uri=https://edu.shanxiyixue.com/mycb&state=rmBNL4ZpqeDXdU7W
};
// const qqlogin =() =>{
//   location.href="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=102024981&redirect_uri=http://huchunlin.cn/loginserver/wxlogin&state=Vr12qQmurwoRYeV7"
// }
const loginIconList = [
  {
    icon: login_wx,
    name: "WeiXin",
  },
  // {
  //   icon: '../../assets/images/login/icon_wb.png',
  //   name: 'WeiBo'
  // },
  {
    icon: login_qq,
    name: "QQ",
  },
  // {
  //   icon: '../../assets/images/login/icon_zfb.png',
  //   name: 'Alipay'
  // }
];

const imgVerification = reactive({
  img: "",
  token: "",
});

const pwdFormRef = ref("pwdFormRef");
const pwdForm = reactive({
  telCode: "86",
  phone: "",
  loginPwd: "",
  verificationCode: "",
  imageVerification: "",
  isAgreement: true,
});

/** 账号登录：是否按身份证号识别（与手机号共用同一输入框） */
const isIdCardAccount = (val) => /^\d{17}[\dXx]$/.test(String(val || "").trim());
const isPhoneAccount = (val) => /^1\d{10}$/.test(String(val || "").trim());
/** 本次密码登录是否走身份证号接口（实人认证身份参数用） */
const pwdLoginByIdCard = ref(false);
/** 按位数切换前缀：超过 11 位视为身份证，显示人员图标；否则显示 +86 */
const pwdAccountShowIdCardPrefix = computed(() => {
  const account = String(pwdForm.phone || "").trim();
  return account.length > 11;
});

const pwdRules = reactive({
  telCode: [
    {
      required: true,
      message: "请选择国家/地区",
      trigger: "change",
    },
  ],
  phone: [
    {
      required: true,
      validator: (_rule, value, callback) => {
        const account = String(value || "").trim();
        if (!account) {
          callback(new Error("请输入手机号或身份证号"));
          return;
        }
        if (isIdCardAccount(account) || isPhoneAccount(account)) {
          callback();
          return;
        }
        callback(new Error("请输入正确的手机号或18位身份证号"));
      },
      trigger: "blur",
    },
  ],
  loginPwd: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    },
  ],
  imageVerification: [
    {
      required: true,
      message: "请输入图形验证码",
      trigger: "blur",
    },
  ],
});

const codeFormRef = ref("codeFormRef");

const codeRules = reactive({
  telCode: [
    {
      required: true,
      message: "请选择国家/地区",
      trigger: "change",
    },
  ],
  phone: [
    {
      required: true,
      message: "请输入手机号",
      trigger: "blur",
    },
  ],
  verificationCode: [
    {
      required: true,
      message: "请输入短信验证码",
      trigger: "blur",
    },
  ],
  imageVerification: [
    {
      required: true,
      message: "请输入图形验证码",
      trigger: "blur",
    },
  ],
});
const shopConfig = ref({});
const wxCode = ref("");
const showLogin = ref(true);
// setSession("userInfo", "");

const encrypt = ref(null);
/** 当前会话是否已完成登录前人脸活体（sessionStorage） */
const loginFaceOk = ref(false);
/** 租户是否开启实人认证（展示身份证人脸登录页签） */
const enableRealPersonLogin = computed(() => {
  return !!(
    shopData?.value?.config?.enableRealPersonVerify ||
    shopConfig.value?.enableRealPersonVerify
  );
});
const faceLoginIdCard = ref("");
const faceLoginLoading = ref(false);
/** 是否为「身份证人脸登录」流程（与账号登录后的实人拦截区分） */
const faceLoginMode = ref(false);

// --------------- 人脸二维码相关（遗留，已由实人认证弹窗替代） ---------------
const faceQrDialogVisible = ref(false);
const faceQrBase64 = ref("");

// --------------- 实人认证弹窗相关 ---------------
const realPersonDialogVisible = ref(false);
const realPersonCertifyId = ref("");
const realPersonCertifyUrl = ref("");
const realPersonStatus = ref(""); // pending, success, fail
const realPersonQrExpired = ref(false);
const realPersonFailMsg = ref("");
const realPersonDialogTitle = ref("人脸验证");
const realPersonTipText = ref("请使用手机扫描二维码完成验证");
let realPersonPollTimer = null;
let realPersonPollCount = 0;
const REALPERSON_POLL_INTERVAL = 3000; // 3秒
const REALPERSON_POLL_MAX = 100; // 最多轮询100次（约5分钟）
const pendingLoginResp = ref(null); // 暂存登录响应，认证完成后继续跳转
const isRefreshingRealPersonQr = ref(false); // 刷新二维码期间不触发 close 清理

// --------------- 身份证上传 OCR 相关 ---------------
const realPersonStep = ref("upload"); // upload | qrcode
const idCardFrontImageUrl = ref("");
const idCardBackImageUrl = ref("");
const idCardOcrLoading = ref(false);
const idCardOcrResult = ref(null); // { name, idNumber, startDate, endDate, issueOrgan }
const idCardFrontReady = ref(false);
const idCardBackReady = ref(false);
const isLiveness = ref(false);
/** 后续登录：本机自拍 VIAPI（有底图） */
const loginViapiMode = ref(false);
const loginViapiPreview = ref("");
const loginViapiReady = ref(false);
const loginViapiOpening = ref(false);
const loginViapiSubmitting = ref(false);
/** 无摄像头 / 打开失败时的提示文案（有值则展示引导面板） */
const loginViapiCamError = ref("");
const loginViapiVideoRef = ref(null);
let loginViapiStream = null;
const realPersonRetryAction = ref("refresh_qr");
/** 缺底图补偿：复用库内身份证信息，跳过上传 */
const reuseStoredIdInfo = ref(false);

/** 打开实人认证弹窗（账号/短信登录拦截，或身份证人脸登录） */
async function openRealPersonDialog(loginResp, isLivenessFlag = false, asFaceLogin = false) {
  // 修改说明：拦截刷脸前清残留学员 token，避免 stored-id-info 串到上一账号 修改功能开始 #20260819141500 2026-08-19 14:15:00
  removeToken();
  setSession("userInfo", "");
  // 修改功能结束 #20260819141500
  faceLoginMode.value = !!asFaceLogin;
  pendingLoginResp.value = loginResp;
  realPersonStatus.value = "";
  realPersonQrExpired.value = false;
  realPersonFailMsg.value = "";
  realPersonPollCount = 0;
  realPersonCertifyUrl.value = "";
  realPersonCertifyId.value = "";
  realPersonRetryAction.value = "refresh_qr";
  isLiveness.value = isLivenessFlag;
  reuseStoredIdInfo.value = false;

  resetOcrResult();

  if (isLivenessFlag) {
    realPersonStep.value = "qrcode";
    realPersonDialogTitle.value = "人脸验证";
    realPersonTipText.value = "请正对摄像头完成人脸验证";
    loginViapiMode.value = false;
    realPersonDialogVisible.value = true;
    await startLivenessVerify();
    return;
  }

  // 首次认证弹窗：单独拉训档 OCR + 证件照反显（登录 / 开课 / 看课三场景共用）
  await applyStoredIdInfoFromServer(loginResp);

  const canReuse =
    (reuseStoredIdInfo.value ||
      loginResp?.reuseStoredIdInfo === true ||
      loginResp?.reuseStoredIdInfo === "true") &&
    idCardOcrResult.value?.name &&
    idCardOcrResult.value?.idNumber;

  if (canReuse) {
    reuseStoredIdInfo.value = true;
    idCardFrontReady.value = true;
    idCardBackReady.value = true;
    realPersonStep.value = "upload";
    realPersonDialogTitle.value = "人脸验证";
    realPersonTipText.value = "请核对身份证信息，确认无误后继续认证；有误可修改或重新上传";
    realPersonDialogVisible.value = true;
  } else {
    realPersonStep.value = "upload";
    realPersonDialogTitle.value = "人脸验证";
    realPersonTipText.value =
      idCardFrontImageUrl.value || idCardBackImageUrl.value
        ? "请核对或补全身份证信息后继续认证"
        : "请先上传身份证人像面与国徽面，再扫码完成验证";
    realPersonDialogVisible.value = true;
  }
}

/** 进首次认证弹窗时查询库内证件（不依赖登录回包塞图） */
async function applyStoredIdInfoFromServer(loginResp) {
  const faceId = (faceLoginIdCard.value || "").trim().toUpperCase();
  const phoneRaw = (pwdForm.phone || "").trim();
  const lookLikeId =
    faceLoginMode.value ||
    (!!faceId && !phoneRaw) ||
    (/^\d{17}[\dXx]$/.test(phoneRaw) && !/^1\d{10}$/.test(phoneRaw));
  const payload = lookLikeId
    ? {
        idCard: (faceId || (loginResp && loginResp.certNo) || phoneRaw || "").toUpperCase(),
        telCode: "86",
      }
    : {
        phone: phoneRaw,
        telCode: pwdForm.telCode || "86",
      };
  if (!payload.phone && !payload.idCard) {
    // 兜底：仅用登录回包文案（无图）
    if (
      (loginResp?.reuseStoredIdInfo === true || loginResp?.reuseStoredIdInfo === "true") &&
      loginResp?.certName &&
      loginResp?.certNo
    ) {
      reuseStoredIdInfo.value = true;
      idCardOcrResult.value = {
        name: loginResp.certName,
        idNumber: loginResp.certNo,
        startDate: loginResp.idOcrValidBegin || "",
        endDate: loginResp.idOcrValidEnd || "",
        issueOrgan: "",
      };
      idCardFrontReady.value = true;
      idCardBackReady.value = true;
    }
    return;
  }
  try {
    const data = await realPersonStoredIdInfo(payload);
    if (!data || data.exists === false || data.exists === "false") {
      if (
        (loginResp?.reuseStoredIdInfo === true || loginResp?.reuseStoredIdInfo === "true") &&
        loginResp?.certName &&
        loginResp?.certNo
      ) {
        reuseStoredIdInfo.value = true;
        idCardOcrResult.value = {
          name: loginResp.certName,
          idNumber: loginResp.certNo,
          startDate: loginResp.idOcrValidBegin || "",
          endDate: loginResp.idOcrValidEnd || "",
          issueOrgan: "",
        };
        idCardFrontReady.value = true;
        idCardBackReady.value = true;
      }
      return;
    }
    if (data.reuseStoredIdInfo === true || data.reuseStoredIdInfo === "true") {
      reuseStoredIdInfo.value = true;
    }
    if (data.certName || data.certNo) {
      idCardOcrResult.value = {
        name: data.certName || "",
        idNumber: data.certNo || "",
        startDate: data.idOcrValidBegin || "",
        endDate: data.idOcrValidEnd || "",
        issueOrgan: "",
      };
    }
    const okUrl = (u) =>
      !!u &&
      (/^https?:\/\//i.test(u) || String(u).indexOf("data:image/") === 0 || String(u).indexOf("/") === 0);
    const front = (data.idCardFrontImg || "").toString().trim();
    const back = (data.idCardBackImg || "").toString().trim();
    if (okUrl(front)) {
      idCardFrontImageUrl.value = front;
      idCardFrontReady.value = true;
    }
    if (okUrl(back)) {
      idCardBackImageUrl.value = back;
      idCardBackReady.value = true;
    }
  } catch (e) {
    console.warn("[realperson] stored-id-info failed", e);
    if (
      (loginResp?.reuseStoredIdInfo === true || loginResp?.reuseStoredIdInfo === "true") &&
      loginResp?.certName &&
      loginResp?.certNo
    ) {
      reuseStoredIdInfo.value = true;
      idCardOcrResult.value = {
        name: loginResp.certName,
        idNumber: loginResp.certNo,
        startDate: loginResp.idOcrValidBegin || "",
        endDate: loginResp.idOcrValidEnd || "",
        issueOrgan: "",
      };
      idCardFrontReady.value = true;
      idCardBackReady.value = true;
    }
  }
}

/** 身份证上传前校验 */
function beforeIdCardUpload(file) {
  const isImage = file.type.startsWith("image/");
  if (!isImage) {
    ElMessage.error("只能上传图片文件");
    return false;
  }
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    ElMessage.error("图片大小不能超过 5MB");
    return false;
  }
  return true;
}

/** 身份证上传并 OCR 识别（face=正面 / back=背面） */
async function handleIdCardUpload(options, side = "face") {
  const file = options.file;
  idCardOcrLoading.value = true;

  try {
    const reader = new FileReader();
    const dataUrl = await new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
    const base64 = dataUrl.split(",")[1];

    if (side === "face") {
      idCardFrontImageUrl.value = dataUrl;
      idCardFrontReady.value = false;
    } else {
      idCardBackImageUrl.value = dataUrl;
      idCardBackReady.value = false;
    }

    const ocrResp = await ocrIdCard({ imageBase64: base64 });
    if (!ocrResp) {
      ElMessage.error("身份证识别失败，请重试");
      return;
    }

    if (!idCardOcrResult.value) {
      idCardOcrResult.value = {
        name: "",
        idNumber: "",
        startDate: "",
        endDate: "",
        issueOrgan: "",
      };
    }

    const detected = String(ocrResp.side || "").toLowerCase();
    // 以 OCR 识别面为准填入对应框；识别不到时再按点击的上传框
    const fillSide =
      detected === "face" || detected === "back" ? detected : side;
    if (fillSide === "face") {
      const faceName = (ocrResp.name || "").trim();
      const faceId = (ocrResp.idNumber || "").trim();
      if (!faceName || !isValidIdCardNumber(faceId)) {
        ElMessage.error("姓名或身份证号识别不完整（含校验位），请上传清晰完整的人像面");
        if (side === "face") {
          idCardFrontImageUrl.value = "";
          idCardFrontReady.value = false;
        } else {
          idCardBackImageUrl.value = "";
          idCardBackReady.value = false;
        }
        return;
      }
      idCardOcrResult.value.name = faceName;
      idCardOcrResult.value.idNumber = faceId;
      idCardFrontImageUrl.value = dataUrl;
      idCardFrontReady.value = true;
      if (side === "back") {
        idCardBackImageUrl.value = "";
        idCardBackReady.value = false;
        ElMessage.success("已识别为人像面，已填入人像面");
      }
    } else {
      let startDate = ocrResp.startDate || "";
      let endDate = ocrResp.endDate || "";
      if (ocrResp.validPeriod && (!startDate || !endDate)) {
        const parts = String(ocrResp.validPeriod).split("-");
        if (parts.length >= 2) {
          startDate = parts[0].trim();
          endDate = parts.slice(1).join("-").trim();
        }
      }
      const periodErr = validateIdCardValidPeriodRecognized(startDate, endDate);
      if (periodErr) {
        ElMessage.error(periodErr);
        if (side === "back") {
          idCardBackImageUrl.value = "";
          idCardBackReady.value = false;
        } else {
          idCardFrontImageUrl.value = "";
          idCardFrontReady.value = false;
        }
        return;
      }
      idCardOcrResult.value.startDate = startDate;
      idCardOcrResult.value.endDate = endDate;
      // 签发机关不展示、不作为通过条件
      idCardOcrResult.value.issueOrgan = ocrResp.issueOrgan || "";
      idCardBackImageUrl.value = dataUrl;
      idCardBackReady.value = true;
      if (side === "face") {
        idCardFrontImageUrl.value = "";
        idCardFrontReady.value = false;
        ElMessage.success("已识别为国徽面，已填入国徽面");
      }
    }

    if (idCardFrontReady.value && idCardBackReady.value) {
      ElMessage.success("人像面与国徽面识别完成，请确认信息");
    }
  } catch (e) {
    ElMessage.error(e?.message || "身份证识别异常");
  } finally {
    idCardOcrLoading.value = false;
  }
}

/** 获取 MetaInfo：Glow 不强制；CDN 失败返回 "{}" 直接 init */
async function getRealPersonMetaInfo() {
  return getMetaInfoSoft(2500);
}

/**
 * 阿里云 InitFaceVerify 必填 ReturnUrl。
 * 手机刷脸结束后跳转到 H5 结果页；PC 仍靠轮询拿结果。
 */
function buildRealPersonReturnUrl(type = "certify") {
  const h5Base = (config.h5BaseUrl || `${window.location.origin}/h5`).replace(/\/$/, "");
  const u = new URL(`${h5Base}/pages/realperson-result`);
  if (faceLoginMode.value || pwdLoginByIdCard.value) {
    u.searchParams.set("idCard", (faceLoginIdCard.value || pwdForm.phone || "").trim());
  } else {
    u.searchParams.set("phone", pwdForm.phone || "");
  }
  u.searchParams.set("type", type);
  return u.toString();
}

/** 组装实人认证接口的用户身份参数（手机号登录拦截 / 身份证登录拦截 / 身份证人脸登录） */
function buildRealPersonIdentityPayload() {
  if (faceLoginMode.value || pwdLoginByIdCard.value) {
    return {
      idCard: (faceLoginIdCard.value || pwdForm.phone || "").trim().toUpperCase(),
    };
  }
  return {
    phone: pwdForm.phone || "",
    telCode: pwdForm.telCode || "86",
  };
}

/** 使用 OCR 结果发起实人认证：本端 Init → 展示 certifyUrl 二维码 → 轮询结果 */
async function startRealPersonVerifyWithOcr() {
  if (!idCardOcrResult.value) {
    ElMessage.error("请先完成身份证识别");
    return;
  }
  if (!reuseStoredIdInfo.value && (!idCardFrontReady.value || !idCardBackReady.value)) {
    ElMessage.error("请先完成身份证人像面与国徽面上传识别");
    return;
  }

  const name = idCardOcrResult.value.name?.trim();
  const idNumber = idCardOcrResult.value.idNumber?.trim();
  const startDate = idCardOcrResult.value.startDate?.trim() || "";
  const endDate = idCardOcrResult.value.endDate?.trim() || "";
  const issueOrgan = idCardOcrResult.value.issueOrgan?.trim() || "";

  if (!name) {
    ElMessage.error("请输入姓名");
    return;
  }
  if (!idNumber) {
    ElMessage.error("请输入身份证号");
    return;
  }
  if (!/^\d{17}[\dXx]$/.test(idNumber)) {
    ElMessage.error("身份证号格式不正确");
    return;
  }
  if (faceLoginMode.value) {
    const inputId = (faceLoginIdCard.value || "").trim().toUpperCase();
    if (inputId !== idNumber.toUpperCase()) {
      ElMessage.error("上传的身份证号与登录填写的身份证号不一致");
      return;
    }
  }
  // 复用库内信息时可无有效期；重新上传 OCR 时必填并校验未过期
  if (!reuseStoredIdInfo.value && (!startDate || !endDate)) {
    ElMessage.error("请填写身份证有效期");
    return;
  }
  if (!reuseStoredIdInfo.value || (startDate && endDate)) {
    const periodErr = validateIdCardValidPeriod(startDate, endDate);
    if (periodErr) {
      ElMessage.error(periodErr);
      return;
    }
  }

  try {
    realPersonCertifyUrl.value = "";
    realPersonCertifyId.value = "";
    realPersonStep.value = "qrcode";
    realPersonTipText.value = "请使用手机扫描二维码完成验证";
    realPersonStatus.value = "pending";
    realPersonQrExpired.value = false;
    realPersonFailMsg.value = "";
    realPersonRetryAction.value = "refresh_qr";

    const metaInfo = await getRealPersonMetaInfo();
    const resp = await realPersonInit({
      ...buildRealPersonIdentityPayload(),
      certName: name,
      certNo: idNumber.toUpperCase(),
      idOcrValidBegin: startDate,
      idOcrValidEnd: endDate,
      idOcrIssueOrgan: issueOrgan,
      metaInfo,
      returnUrl: buildRealPersonReturnUrl("certify"),
    });

    if (resp && resp.certifyId && resp.certifyUrl) {
      realPersonCertifyId.value = resp.certifyId;
      realPersonCertifyUrl.value = resp.certifyUrl;
      startRealPersonPolling(false);
    } else {
      handleRealPersonInitFail("人脸验证初始化失败，请稍后重试", false);
    }
  } catch (e) {
    const raw = e?.message || e?.msg || "";
    const msg = friendlyRealPersonError(raw, "人脸验证初始化失败，请稍后重试");
    handleRealPersonInitFail(
      msg,
      /姓名或身份证|核对/.test(msg) || /姓名或身份证|核对/.test(raw)
    );
  }
}

/**
 * Init 失败统一处理：证件问题回到 OCR 核对
 */
function handleRealPersonInitFail(userMsg, preferReupload) {
  realPersonStatus.value = "fail";
  realPersonFailMsg.value = userMsg;
  if (preferReupload) {
    realPersonRetryAction.value = "reupload_id";
  } else {
    realPersonRetryAction.value = "refresh_qr";
  }
}

/** 用户可见错误文案：隐藏技术码，但不要把所有失败都说成姓名证件问题 */
function friendlyRealPersonError(msg, fallback = "操作失败，请稍后重试") {
  if (!msg) return fallback;
  const text = String(msg).trim();
  if (/model|参数非法\(model\)/i.test(text)) {
    return "人脸验证初始化失败，请稍后重试";
  }
  // 后端已给出的明确文案直接用
  if (text.includes("姓名或身份证号校验未通过")) {
    return text;
  }
  if (/姓名|身份证号|证件号|certName|certNo/i.test(text)) {
    return "姓名或身份证号校验未通过，请核对后重试";
  }
  if (/401|400|402|404|参数非法|参数不能为空|userid|requestId/i.test(text)) {
    return fallback;
  }
  return text.replace(/[（(][^）)]*[）)]/g, "").trim() || fallback;
}

/** 重置 OCR 结果，重新上传 */
function resetOcrResult() {
  idCardFrontImageUrl.value = "";
  idCardBackImageUrl.value = "";
  idCardOcrResult.value = null;
  idCardOcrLoading.value = false;
  idCardFrontReady.value = false;
  idCardBackReady.value = false;
}

async function goReuploadIdCard() {
  if (realPersonPollTimer) clearInterval(realPersonPollTimer);
  realPersonStatus.value = "";
  realPersonFailMsg.value = "";
  realPersonCertifyUrl.value = "";
  realPersonCertifyId.value = "";
  reuseStoredIdInfo.value = false;
  isLiveness.value = false;
  realPersonStep.value = "upload";
  realPersonDialogTitle.value = "人脸验证";
  // 已有 OCR 结果：保留供核对，不强制清空；无结果则回到上传
  if (idCardOcrResult.value) {
    realPersonTipText.value =
      "请核对身份证信息，确认无误后继续认证；有误可修改或重新上传";
  } else {
    realPersonTipText.value = "请重新上传身份证人像面与国徽面";
    resetOcrResult();
  }
  if (!idCardFrontImageUrl.value || !idCardBackImageUrl.value) {
    try {
      await applyStoredIdInfoFromServer(pendingLoginResp.value);
    } catch (e) {}
  }
}

/** 发起人脸活体检测（有底图走 VIAPI 自拍；缺底图降级 certify 扫码） */
async function startLivenessVerify() {
  try {
    stopLoginViapiCamera();
    loginViapiMode.value = false;
    loginViapiPreview.value = "";
    loginViapiReady.value = false;
    loginViapiCamError.value = "";
    realPersonCertifyUrl.value = "";
    realPersonCertifyId.value = "";
    realPersonStatus.value = "pending";
    realPersonQrExpired.value = false;
    realPersonFailMsg.value = "";

    const metaInfo = await getRealPersonMetaInfo();
    const resp = await realPersonInitLiveness({
      ...buildRealPersonIdentityPayload(),
      metaInfo,
      returnUrl: buildRealPersonReturnUrl("liveness"),
    });
    if (!resp || !resp.certifyId) {
      handleRealPersonInitFail("人脸验证初始化失败，请稍后重试", false);
      return;
    }
    realPersonCertifyId.value = resp.certifyId;
    // 缺底图降级为实人认证时，改用 query 轮询以便落库人脸底图
    if (resp.verifyMode === "certify") {
      isLiveness.value = false;
      loginViapiMode.value = false;
      reuseStoredIdInfo.value = true;
      realPersonDialogTitle.value = "人脸验证";
      realPersonTipText.value = "请使用手机扫描二维码完成验证";
      if (resp.certifyUrl) {
        realPersonCertifyUrl.value = resp.certifyUrl;
        startRealPersonPolling(false);
      } else {
        handleRealPersonInitFail("人脸验证初始化失败，请稍后重试", false);
      }
      return;
    }
    // 有底图：本机自拍 VIAPI（与课中一致）
    if (resp.verifyMode === "viapi_liveness" || !resp.certifyUrl) {
      loginViapiMode.value = true;
      isLiveness.value = true;
      loginViapiCamError.value = "";
      loginViapiPreview.value = "";
      realPersonTipText.value = "请正对摄像头，将面部移入画面后拍照";
      realPersonStatus.value = "";
      await nextTick();
      await openLoginViapiCamera();
      return;
    }
    // 兼容旧包仍返回 certifyUrl（Glow/CloudAuth）
    realPersonCertifyUrl.value = resp.certifyUrl;
    loginViapiMode.value = false;
    startRealPersonPolling(true);
  } catch (e) {
    const raw = e?.message || e?.msg || "";
    const msg = friendlyRealPersonError(raw, "人脸验证初始化失败，请稍后重试");
    const preferReupload =
      raw.includes("证件信息不完整") ||
      raw.includes("重新上传") ||
      /姓名或身份证|核对/.test(msg);
    handleRealPersonInitFail(msg, preferReupload);
    if (preferReupload) {
      isLiveness.value = false;
      loginViapiMode.value = false;
    }
  }
}

function stopLoginViapiCamera() {
  try {
    if (loginViapiStream) {
      loginViapiStream.getTracks().forEach((t) => t.stop());
    }
  } catch (e) {}
  loginViapiStream = null;
  loginViapiReady.value = false;
  const video = loginViapiVideoRef.value;
  if (video) {
    try {
      video.srcObject = null;
    } catch (e) {}
  }
}

/** 将 getUserMedia / 设备探测错误转为用户可读提示 */
function resolveLoginViapiCamError(err) {
  const name = err?.name || "";
  const msg = String(err?.message || err?.msg || "");
  if (name === "NotFoundError" || name === "DevicesNotFoundError" || /not found|无.*设备|no.*device/i.test(msg)) {
    return "未检测到可用摄像头";
  }
  if (name === "NotAllowedError" || name === "PermissionDeniedError" || /permission|权限|denied/i.test(msg)) {
    return "摄像头权限被拒绝，请在浏览器中允许后重试";
  }
  if (name === "NotReadableError" || name === "TrackStartError" || /in use|占用|busy/i.test(msg)) {
    return "摄像头被其他程序占用，请关闭后重试";
  }
  if (name === "OverconstrainedError" || name === "ConstraintNotSatisfiedError") {
    return "当前摄像头不满足条件，请换设备或使用手机端";
  }
  if (name === "SecurityError" || /https|secure|不安全/i.test(msg)) {
    return "当前环境无法使用摄像头（需 HTTPS）";
  }
  if (!navigator?.mediaDevices?.getUserMedia) {
    return "当前浏览器不支持摄像头";
  }
  return msg || "无法打开摄像头";
}

async function openLoginViapiCamera() {
  loginViapiCamError.value = "";
  if (typeof navigator === "undefined" || !navigator.mediaDevices?.getUserMedia) {
    loginViapiCamError.value = "当前浏览器不支持摄像头";
    ElMessage.warning("当前浏览器不支持摄像头，建议使用手机端登录并观看课程");
    return;
  }
  loginViapiOpening.value = true;
  stopLoginViapiCamera();
  try {
    // 先枚举设备：无 videoinput 时直接提示（部分浏览器需先授权才能列出 label，但 deviceId 仍可判断有无）
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasCam = devices.some((d) => d.kind === "videoinput");
      if (devices.length > 0 && !hasCam) {
        loginViapiCamError.value = "未检测到可用摄像头";
        ElMessage.warning("未检测到摄像头，建议使用手机端登录并观看课程");
        return;
      }
    } catch (e) {
      // enumerate 失败不阻断，继续尝试 getUserMedia
    }
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { facingMode: "user", width: { ideal: 640 }, height: { ideal: 480 } },
    });
    loginViapiStream = stream;
    await nextTick();
    const video = loginViapiVideoRef.value;
    if (!video) {
      throw new Error("摄像头预览未就绪");
    }
    video.srcObject = stream;
    await video.play().catch(() => {});
    loginViapiReady.value = true;
    loginViapiCamError.value = "";
  } catch (e) {
    loginViapiReady.value = false;
    loginViapiCamError.value = resolveLoginViapiCamError(e);
    ElMessage.warning(loginViapiCamError.value + "，建议使用手机端登录并观看课程");
  } finally {
    loginViapiOpening.value = false;
  }
}

async function captureLoginViapiShot() {
  const video = loginViapiVideoRef.value;
  if (!video || !video.videoWidth) {
    ElMessage.warning("摄像头未就绪，请先打开摄像头");
    return;
  }
  const canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  canvas.getContext("2d").drawImage(video, 0, 0);
  loginViapiPreview.value = canvas.toDataURL("image/jpeg", 0.92);
  stopLoginViapiCamera();
  realPersonStatus.value = "";
  realPersonFailMsg.value = "";
}

async function retakeLoginViapiShot() {
  loginViapiPreview.value = "";
  realPersonStatus.value = "";
  realPersonFailMsg.value = "";
  await nextTick();
  await openLoginViapiCamera();
}

async function submitLoginViapiShot() {
  if (!loginViapiPreview.value || loginViapiSubmitting.value) return;
  loginViapiSubmitting.value = true;
  realPersonFailMsg.value = "";
  try {
    const resp = await realPersonViapiVerify({
      certifyId: realPersonCertifyId.value,
      faceImageBase64: loginViapiPreview.value,
      clientType: 1,
      ...buildRealPersonIdentityPayload(),
    });
    if (resp && (resp.passed === true || resp.passed === "true")) {
      realPersonStatus.value = "success";
      await completeAfterRealPersonVerify();
    } else {
      realPersonStatus.value = "fail";
      realPersonFailMsg.value = resp?.message || "人脸验证未通过，请重试";
    }
  } catch (e) {
    realPersonStatus.value = "fail";
    realPersonFailMsg.value = e?.message || e?.msg || "人脸验证失败，请重试";
  } finally {
    loginViapiSubmitting.value = false;
  }
}

/** 刷脸通过后统一 complete 签发 token（账号登录 / 人脸登录） */
async function completeAfterRealPersonVerify() {
  try {
    const { name: osName, version: osVersion } = getOsInfo();
    const { name: browserName, version: browserVersion } = getBrowserInfo();
    const payload = {
      certifyId: realPersonCertifyId.value,
      clientType: 1,
      browser: browserName,
      browserVersion,
      os: osName,
      osVersion,
    };
    const identity = buildRealPersonIdentityPayload();
    if (identity.idCard) payload.idCard = identity.idCard;
    if (identity.phone) {
      payload.phone = identity.phone;
      payload.telCode = identity.telCode || "86";
    }
    // 仅人脸登录页签可无密码放行凭证；密码/短信刷脸必须带 permit
    if (faceLoginMode.value) {
      payload.faceLogin = true;
    }
    const loginResp = await realPersonLoginComplete(payload);
    if (loginResp && loginResp.token) {
      const currentArchiveStatus =
        loginResp.archiveStatus !== undefined ? loginResp.archiveStatus : null;
      setStore("archiveStatus", currentArchiveStatus);
      setSession("archiveStatus", currentArchiveStatus);
      setTimeout(() => {
        realPersonDialogVisible.value = false;
        faceLoginMode.value = false;
        handleLoginSuccess(loginResp);
      }, 1000);
    } else {
      realPersonStatus.value = "fail";
      realPersonFailMsg.value = "登录失败，请重试";
    }
  } catch (e) {
    realPersonStatus.value = "fail";
    realPersonFailMsg.value = e?.message || "登录失败，请重试";
    ElMessage.error(e?.message || "登录失败，请重试");
  }
}

/** 兼容旧名 */
async function completeFaceLogin() {
  await completeAfterRealPersonVerify();
}

/** 轮询认证结果 */
function startRealPersonPolling(livenessMode) {
  if (realPersonPollTimer) clearInterval(realPersonPollTimer);
  realPersonPollCount = 0;
  realPersonPollTimer = setInterval(async () => {
    realPersonPollCount++;
    if (realPersonPollCount > REALPERSON_POLL_MAX) {
      clearInterval(realPersonPollTimer);
      realPersonQrExpired.value = true;
      return;
    }
    if (!realPersonCertifyId.value) {
      return;
    }
    try {
      const queryFn = livenessMode ? realPersonQueryLiveness : realPersonQuery;
      const resp = await queryFn({
        certifyId: realPersonCertifyId.value,
        ...buildRealPersonIdentityPayload(),
      });
      if (resp.passed === true) {
        clearInterval(realPersonPollTimer);
        realPersonStatus.value = "success";
        await completeAfterRealPersonVerify();
      } else if (resp.passed === false) {
        clearInterval(realPersonPollTimer);
        realPersonStatus.value = "fail";
        realPersonFailMsg.value = friendlyRealPersonError(
          resp.message,
          "验证未通过，请重试"
        );
        realPersonRetryAction.value = resp.retryAction || "refresh_qr";
      }
    } catch (e) {
      // 查询异常，继续轮询
    }
  }, REALPERSON_POLL_INTERVAL);
}

/** 刷新二维码 */
async function refreshRealPersonQr() {
  if (realPersonPollTimer) clearInterval(realPersonPollTimer);
  isRefreshingRealPersonQr.value = true;
  realPersonStatus.value = "";
  realPersonQrExpired.value = false;
  realPersonFailMsg.value = "";
  realPersonPollCount = 0;
  try {
    if (isLiveness.value) {
      await startLivenessVerify();
    } else if (reuseStoredIdInfo.value && idCardOcrResult.value) {
      await startRealPersonVerifyWithOcr();
    } else if (idCardOcrResult.value && idCardFrontReady.value) {
      await startRealPersonVerifyWithOcr();
    } else {
      await openRealPersonDialog(pendingLoginResp.value, false, faceLoginMode.value);
    }
  } finally {
    isRefreshingRealPersonQr.value = false;
  }
}

/** 实人认证弹窗关闭 */
function handleRealPersonDialogClose() {
  if (isRefreshingRealPersonQr.value) return;
  stopLoginViapiCamera();
  loginViapiMode.value = false;
  loginViapiPreview.value = "";
  loginViapiCamError.value = "";
  if (realPersonStatus.value !== "success") {
    if (realPersonPollTimer) clearInterval(realPersonPollTimer);
    faceLoginMode.value = false;
  }
}

const handleLoginFaceVerify = async () => {
  if (!enableRealPersonLogin.value) {
    ElMessage.warning("当前店铺未开启实人认证");
    return;
  }
  const idCard = (faceLoginIdCard.value || "").trim();
  if (!idCard) {
    ElMessage.warning("请先填写身份证号");
    return;
  }
  if (!/^\d{17}[\dXx]$/.test(idCard)) {
    ElMessage.warning("请填写正确的18位身份证号");
    return;
  }

  faceLoginLoading.value = true;
  try {
    const check = await realPersonLoginCheck({ idCard });
    if (!check?.enableRealPersonVerify) {
      ElMessage.warning("当前店铺未开启实人认证");
      return;
    }
    if (!check.exists) {
      ElMessage.error("未找到该身份证对应的学员账号，请先联系管理员绑定身份证");
      return;
    }
    const isLivenessFlag = check.realNameVerifyStatus === 1;
    // 将 check 结果作为 loginResp 传入，便于缺底图补偿复用证件信息
    await openRealPersonDialog(check, isLivenessFlag, true);
  } catch (e) {
    ElMessage.error(e?.message || "人脸登录预检查失败");
  } finally {
    faceLoginLoading.value = false;
  }
};

onMounted(() => {
  if (
    window.location.hostname == "hnkdtdxlkspx.ykumda.com" ||
    window.location.hostname == "hnkdtdxlkcxx.ykumda.com" ||
    window.location.hostname == "train.shanxiyixue.com" ||
    window.location.hostname == "aufe.ykumda.com" ||
    window.location.hostname == "cjdxyx.ykumda.com" ||
    window.location.hostname == "cjdxtk.ykumda.com" ||
    window.location.hostname == "xwyh.shanxiyixue.com" ||
    window.location.hostname == "xue.coeedu.cn" ||
    window.location.hostname == "guozijy.com" ||
    window.location.hostname == "www.guozijy.com" ||
    window.location.hostname == "kecheng.wuyouyanxue.cn" ||
    window.location.hostname == "xnzftl.ykumda.com"
  ) {
    showLogin.value = false;
  }
  wxCode.value = route.query.code;
  hrefUrl.value = window.location.hostname;
  if (wxCode.value) {
    loginPlat.value = 2;
    wxCodeLogin();
  }
  const casTicket = route.query.ticket;
  if (casTicket) {
    // 有 ticket 先去 /cas；由中转页校验 enableCasLogin，非 CAS 店会退回本地登录
    const q = new URLSearchParams({
      ticket: String(casTicket),
      ...(route.query.redirect
        ? { redirect: String(route.query.redirect) }
        : {}),
    }).toString();
    window.location.replace(`/cas?${q}`);
    return;
  }
  errorNum.value = parseInt(getStore("errorNum")) || 0;
  adminErrorNum.value = parseInt(getStore("adminErrorNum")) || 0;
  setSession("userInfo", "");
  // 清空旧的归档状态，避免读取到上次登录的残留值（解决偶发问题）
  setSession("archiveStatus", null);
  if (errorNum.value >= 2) {
    // 获取图形验证码
    getImgVerification();
  }
  if (adminErrorNum.value >= 2) {                                   // ← 新增
    // 获取管理员图形验证码
    getAdminImgVerification();
  }
  jsonp("//gateway.doityun.com/ip/info", (res) => {
    ipInfo = res;
    setSession("ipInfo", ipInfo);
  });
  getEnumList("TelCodeEnum", "arr").then((res) => {
    opts.TelCodeEnum = res;
  });
  getShopInfo().then((res) => {
    shopConfig.value = res.config || {};
    // CAS 店访问 /login：改走轻量中转页，不加载本页登录表单
    if (
      !allowLocalLoginPage() &&
      isCasLoginEnabled(shopConfig.value)
    ) {
      const q = route.query.redirect
        ? `?redirect=${encodeURIComponent(String(route.query.redirect))}`
        : "";
      window.location.replace(`/cas${q}`);
      return;
    }
    hideCasTransit();
  }).catch(() => {
    hideCasTransit();
  });

  const publicKey =
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkmF5qnO9d4bNoBOoziLECcLVkwvDujiGt9u7rOkr+V7YvZMTSw3+UiaFhtJHxHpyB8sDXbOUAYzBt3sH43VniXVfw2cR6eW7jVfzyFc/lEDuQQRGR79ta781NKY0/mR3YynySlsno8ndXd8ncsjnURzHxxWamciFIcUCL13xDirjSAEvfF2SReq62jE3xkujM2hGmflpyFHgA9mEnQCBWr5AdljVlXlaST5g+ThsHUO9dRAqGFqudIvSNtQ45Dp/QrmMQE6QbdiSHGnMOwEJ3HqrSYKQVDDNfaObEkieXCJEi2SibOtekQdKTowcDWR7r9vdR+JRWlkPveZdfG7RNwIDAQAB";
  encrypt.value = new JSEncrypt();
  encrypt.value.setPublicKey(publicKey);
});
const bindingWxModel = reactive({
  visible: false,
  title: "绑定手机号",
  userInfo: {},
});

const hanldeClosebindingWxModel = async () => {
  bindingWxModel.visible = false;
  const userInfo = await getUserView();
  if (userInfo) {
    // 获取归档状态（绑定微信时，归档状态应该在微信登录时已保存到 sessionStorage）
    const archiveStatusRaw = getSession("archiveStatus");
    // 统一解析：处理布尔值和字符串
    let finalArchiveStatus = null;
    if (archiveStatusRaw === true || archiveStatusRaw === "true") {
      finalArchiveStatus = true;
    } else if (archiveStatusRaw === false || archiveStatusRaw === "false") {
      finalArchiveStatus = false;
    } else {
      finalArchiveStatus = null;
    }

    // 只有明确未归档（false）或未设置（null）时才跳转，已归档（true）不跳转
    if (
      shopData.value.enabledBranchShop == true &&
      shopData.value.contractExist == true &&
      !userInfo.isReadContract &&
      finalArchiveStatus !== true
    ) {
      router.replace({ path: "/contract" });
    } else {
      if (route.query.redirect) {
        let redirectUrl = decodeURIComponent(route.query.redirect);
        if (redirectUrl.indexOf("?") !== -1) {
          const redirectUrlArr = redirectUrl.split("?");
          redirectUrl = redirectUrlArr[0];
          const query = {};
          const queryArr = redirectUrlArr[1].split("&");
          for (let i = 0; i < queryArr.length; i++) {
            const keyValue = queryArr[i].split("=");
            query[keyValue[0]] = keyValue[1];
          }
          router.replace({ path: redirectUrl, query });
        } else {
          router.replace({ path: redirectUrl });
        }
      } else {
        router.replace({ path: "/" });
      }
    }
  }
};
const wxCodeLogin = async () => {
  const data = {};
  data.loginIp = ipInfo.ip;
  data.city = ipInfo.city;
  const { name: osName, version: osVersion } = getOsInfo();
  const { name: browserName, version: browserVersion } = getBrowserInfo();
  data.os = osName;
  data.osVersion = osVersion;
  data.browser = browserName;
  data.browserVersion = browserVersion;
  wxLogin({ ...data, authType: 1, code: wxCode.value, clientType: 1 }).then(
    async (res) => {
      if (res) {
        if (res.bindUser) {
          setToken(res.token);

          // 保存归档状态（先保存，再判断，避免时序问题）
          const currentArchiveStatus =
            res.archiveStatus !== undefined ? res.archiveStatus : null;
          console.log(
            "🔵 微信登录 - 保存归档状态到 localStorage:",
            currentArchiveStatus,
            `(${typeof currentArchiveStatus})`
          );
          setStore("archiveStatus", currentArchiveStatus); // 保存到 localStorage（持久化）
          setSession("archiveStatus", currentArchiveStatus); // 同时保存到 sessionStorage 保持兼容
          // 验证是否保存成功
          const savedValue = getStore("archiveStatus");
          console.log(
            "🔵 微信登录 - 验证 localStorage 保存结果:",
            savedValue,
            savedValue ? `(已保存)` : `(保存失败或为null)`
          );

          const userInfo = await getUserView();
          if (userInfo) {
            // 优先使用接口返回的 archiveStatus（最可靠），避免从 sessionStorage 读取时可能存在的时序问题
            // 如果接口返回了值，就用接口的值；如果接口没返回，才从 sessionStorage 读取
            let finalArchiveStatus = currentArchiveStatus;
            if (
              finalArchiveStatus === null ||
              finalArchiveStatus === undefined
            ) {
              const archiveStatusFromStorage = getSession("archiveStatus");
              // 统一解析：处理布尔值和字符串
              if (
                archiveStatusFromStorage === true ||
                archiveStatusFromStorage === "true"
              ) {
                finalArchiveStatus = true;
              } else if (
                archiveStatusFromStorage === false ||
                archiveStatusFromStorage === "false"
              ) {
                finalArchiveStatus = false;
              } else {
                finalArchiveStatus = null;
              }
            }

            // 只有明确未归档（false）或未设置（null）时才跳转，已归档（true）不跳转
            if (
              shopData.value.enabledBranchShop == true &&
              shopData.value.contractExist == true &&
              !userInfo.isReadContract &&
              finalArchiveStatus !== true
            ) {
              router.replace({ path: "/contract" });
            } else {
              if (route.query.redirect) {
                let redirectUrl = decodeURIComponent(route.query.redirect);
                if (redirectUrl.indexOf("?") !== -1) {
                  const redirectUrlArr = redirectUrl.split("?");
                  redirectUrl = redirectUrlArr[0];
                  const query = {};
                  const queryArr = redirectUrlArr[1].split("&");
                  for (let i = 0; i < queryArr.length; i++) {
                    const keyValue = queryArr[i].split("=");
                    query[keyValue[0]] = keyValue[1];
                  }
                  router.replace({ path: redirectUrl, query });
                } else {
                  router.replace({ path: redirectUrl });
                }
              } else {
                router.replace({ path: "/" });
              }
            }
          }
        } else {
          //         bindingWxModel.userInfo = {
          //           gender: 1,
          // headImg: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKr2HLyKK8n9xTnHGnqg7OZHV393Ynty7EniagIcYichEictnE65X3WFmN26UTmWswhCql0Q0vbn38zw/132",
          // nickname: "_@",
          // unionId: "o-s341LL6PQtbxNc2sPH1rAaH7QQ"
          //         }
          bindingWxModel.userInfo = res.authInfo;
          bindingWxModel.visible = true;
          bindingWxModel.title = "绑定手机号";
        }
      }
    }
  );
};
const choosePop1 = ref(null);
const choosePop2 = ref(null);
const openPopver = () => {
  const activeIndex = opts.TelCodeEnum.findIndex((item) => {
    return item.code + item.standardDesc === pwdForm.telCode + opts.country;
  });
  const activeItem = opts.TelCodeEnum.splice(activeIndex, 1);
  opts.TelCodeEnum.unshift(activeItem[0]);
};
const handleSelectTelCode = (row) => {
  pwdForm.telCode = row.code;
  opts.country = row.standardDesc;
  choosePop1.value.hide();
  choosePop2.value.hide();
};

const generateJsonpCallback = () => {
  return `jsonpcallback_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
};

const jsonp = (url, callback) => {
  const funcName = generateJsonpCallback();
  window[funcName] = callback;
  const script = document.createElement("script");
  script.src = `${url}?callback=${funcName}`;
  script.type = "text/javascript";
  document.body.appendChild(script);
};

// 获取系统信息
const getOsInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  let name = "Unknown";
  let version = "Unknown";
  if (userAgent.indexOf("win") > -1) {
    name = "Windows";
    if (userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if (
      userAgent.indexOf("windows nt 5.1") > -1 ||
      userAgent.indexOf("windows nt 5.2") > -1
    ) {
      version = "Windows XP";
    } else if (userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if (
      userAgent.indexOf("windows nt 6.1") > -1 ||
      userAgent.indexOf("windows 7") > -1
    ) {
      version = "Windows 7";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows 8") > -1
    ) {
      version = "Windows 8";
    } else if (userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if (
      userAgent.indexOf("windows nt 6.2") > -1 ||
      userAgent.indexOf("windows nt 10.0") > -1
    ) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if (userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if (userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if (
    userAgent.indexOf("x11") > -1 ||
    userAgent.indexOf("unix") > -1 ||
    userAgent.indexOf("sunname") > -1 ||
    userAgent.indexOf("bsd") > -1
  ) {
    name = "Unix";
  } else if (userAgent.indexOf("linux") > -1) {
    if (userAgent.indexOf("android") > -1) {
      name = "Android";
    } else {
      name = "Linux";
    }
  } else {
    name = "Unknown";
  }
  return {
    name,
    version,
  };
};
const getBrowserInfo = () => {
  /* eslint-disable */
  const Sys = {};
  const ua = navigator.userAgent.toLowerCase();
  let s;
  (s = ua.match(/rv:([\d.]+)\) like gecko/))
    ? (Sys.ie = s[1])
    : (s = ua.match(/msie ([\d]+)/))
    ? (Sys.ie = s[1])
    : (s = ua.match(/edge\/([\d]+)/))
    ? (Sys.edge = s[1])
    : (s = ua.match(/firefox\/([\d]+)/))
    ? (Sys.firefox = s[1])
    : (s = ua.match(/(?:opera|opr).([\d]+)/))
    ? (Sys.opera = s[1])
    : (s = ua.match(/chrome\/([\d]+)/))
    ? (Sys.chrome = s[1])
    : (s = ua.match(/version\/([\d]+).*safari/))
    ? (Sys.safari = s[1])
    : 0;
  // 根据关系进行判断
  if (Sys.ie)
    return {
      name: "IE",
      version: Sys.ie,
    };
  if (Sys.edge)
    return {
      name: "EDGE",
      version: Sys.edge,
    };
  if (Sys.firefox)
    return {
      name: "Firefox",
      version: Sys.firefox,
    };
  if (Sys.chrome)
    return {
      name: "Chrome",
      version: Sys.chrome,
    };
  if (Sys.opera)
    return {
      name: "Opera",
      version: Sys.opera,
    };
  if (Sys.safari)
    return {
      name: "Safari",
      version: Sys.safari,
    };
  return {
    name: "Unkonwn",
    version: "0.0.0",
  };
};

const txt = ref("获取验证码");
const disabled = ref(false);
const timeOut = () => {
  let num = 60;
  disabled.value = true;
  txt.value = num;
  let nt = setInterval(() => {
    if (num <= 0) {
      clearInterval(nt);
      disabled.value = false;
      txt.value = "重新获取";
    } else {
      num--;
      txt.value = num + "s";
    }
  }, 1000);
};

// 验证码配置
const captchaConfig = reactive({
  captchaId: "", // captchaId
});

const captchaVisible = ref(false);
let captchaValidate = null; // 存储验证结果

const getCode = async () => {
  if (disabled.value) return;
  // 优化手机号校验：转为字符串避免 parseInt 问题
  const phone = String(pwdForm.phone).trim();
  const phoneReg = /^1\d{10}$/;
  if (!phoneReg.test(phone)) {
    ElMessage.error("请输入正确的11位手机号");
    return;
  }
  try {
    const appKeyRes = await getAppKeyInfo({});
    captchaConfig.captchaId = JSON.parse(appKeyRes).captchaId || "";

    if (captchaConfig.captchaId) {
      captchaVisible.value = true;
    } else {
      ElMessage.warning("验证码配置为空，无法验证");
    }
  } catch (apiErr) {
    // 内层catch：处理接口请求/超时错误
    console.error("获取captchaId失败:", apiErr);
    ElMessage.closeAll(); // 关闭加载提示
    ElMessage.error(apiErr.message || "验证码获取失败，请重试");
    return;
  }
};

// 验证码验证成功
const handleCaptchaSuccess = async (data) => {
  console.log("验证成功:", data);

  // 保存验证结果
  captchaValidate = data.validate;
  // 调用发送短信接口（带上验证结果）
  getMsg({
    phone: pwdForm.phone,
    telCode: pwdForm.telCode,
    verificationCodeType: 2,
    graphicsType: 1,
    lotNumber: captchaValidate.lot_number,
    passToken: captchaValidate.pass_token,
    genTime: captchaValidate.gen_time,
    captchaOutput: captchaValidate.captcha_output,
  }).then((res) => {
    timeOut();
  });
  //
  // try {
  //   const res = await verificationCaptch({});
  //   if (res === "common.success") {
  //   } else {
  //     ElMessage.error("请重试");
  //   }
  // } catch (err) {
  //   ElMessage.error(err.message || "发送失败");
  // }
};

// 验证码错误
const handleCaptchaError = (error) => {
  console.error("验证码错误:", error);
  ElMessage.error(error.message || "验证失败");
};

// 弹框关闭
const handleCaptchaClose = () => {
  console.log("验证码弹框关闭");
};

const submitForm = async (formEl) => {
  const data = {};
  if (!pwdForm.isAgreement) {
    ElMessage.warning("请阅读并同意用户协议");
    return;
  }

  data.loginIp = ipInfo.ip;
  data.city = ipInfo.city;
  const { name: osName, version: osVersion } = getOsInfo();
  const { name: browserName, version: browserVersion } = getBrowserInfo();
  data.os = osName;
  data.osVersion = osVersion;
  data.browser = browserName;
  data.browserVersion = browserVersion;
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      if (tabName.value === "1") {
        if (imgVerification.token) {
          data.imageVerificationToken = imgVerification.token;
          data.imageVerification = pwdForm.imageVerification;
        }

        // 对密码进行RSA加密
        let encryptedPassword = pwdForm.loginPwd;
        if (encrypt.value && pwdForm.loginPwd) {
          const encrypted = encrypt.value.encrypt(pwdForm.loginPwd);
          if (encrypted) {
            encryptedPassword = encrypted;
          }
        }

        const account = String(pwdForm.phone || "").trim();
        const byIdCard = isIdCardAccount(account);
        pwdLoginByIdCard.value = byIdCard;
        if (byIdCard) {
          faceLoginIdCard.value = account.toUpperCase();
        }

        const loginReq = byIdCard
          ? userLoginIdCardPwd({
              clientType: 1,
              idCard: account.toUpperCase(),
              loginPwd: encryptedPassword,
              ...data,
            })
          : userLoginPwd({
              clientType: 1,
              ...pwdForm,
              loginPwd: encryptedPassword,
              ...data,
            });

        loginReq
          .then(async (res) => {
            if (!res) return;
            errorNum.value = 0;
            setStore("errorNum", errorNum.value);

            // 需刷脸：不落 token，校验已在服务端写入放行凭证
            const needRealPerson =
              res.needRealPersonVerify === true ||
              res.needRealPersonVerify === "true";
            if (needRealPerson) {
              await openRealPersonDialog(res, res.realNameVerifyStatus === 1);
              return;
            }

            if (!res.token) return;
            setToken(res.token);

              // 保存归档状态（先保存，再判断，避免时序问题）
              const currentArchiveStatus =
                res.archiveStatus !== undefined ? res.archiveStatus : null;
              console.log(
                "🔵 登录 - 保存归档状态到 localStorage:",
                currentArchiveStatus,
                `(${typeof currentArchiveStatus})`
              );
              setStore("archiveStatus", currentArchiveStatus); // 保存到 localStorage（持久化）
              setSession("archiveStatus", currentArchiveStatus); // 同时保存到 sessionStorage 保持兼容
              // 验证是否保存成功
              const savedValue = getStore("archiveStatus");
              console.log(
                "🔵 登录 - 验证 localStorage 保存结果:",
                savedValue,
                savedValue ? `(已保存)` : `(保存失败或为null)`
              );

              const userInfo = await getUserView();
              if (userInfo) {
                // 优先使用接口返回的 archiveStatus（最可靠），避免从 sessionStorage 读取时可能存在的时序问题
                // 如果接口返回了值，就用接口的值；如果接口没返回，才从 sessionStorage 读取
                let finalArchiveStatus = currentArchiveStatus;
                if (
                  finalArchiveStatus === null ||
                  finalArchiveStatus === undefined
                ) {
                  const archiveStatusFromStorage = getSession("archiveStatus");
                  // 统一解析：处理布尔值和字符串
                  if (
                    archiveStatusFromStorage === true ||
                    archiveStatusFromStorage === "true"
                  ) {
                    finalArchiveStatus = true;
                  } else if (
                    archiveStatusFromStorage === false ||
                    archiveStatusFromStorage === "false"
                  ) {
                    finalArchiveStatus = false;
                  } else {
                    finalArchiveStatus = null;
                  }
                }

                // 只有明确未归档（false）或未设置（null）时才跳转，已归档（true）不跳转
                if (
                  shopData.value.enabledBranchShop == true &&
                  shopData.value.contractExist == true &&
                  !userInfo.isReadContract &&
                  finalArchiveStatus !== true
                ) {
                  router.replace({ path: "/contract" });
                } else {
                  if (
                    route.query.redirect ||
                    window.location.hostname == "hnkdtdxlkspx.ykumda.com" ||
                    window.location.hostname == "hnkdtdxlkcxx.ykumda.com" ||
                    window.location.hostname == "aufe.ykumda.com" ||
                    window.location.hostname == "cjdxyx.ykumda.com" ||
                    window.location.hostname == "cjdxtk.ykumda.com"
                  ) {
                    let redirectUrl = decodeURIComponent(route.query.redirect);
                    if (redirectUrl.indexOf("?") !== -1) {
                      const redirectUrlArr = redirectUrl.split("?");
                      redirectUrl = redirectUrlArr[0];
                      const query = {};
                      const queryArr = redirectUrlArr[1].split("&");
                      for (let i = 0; i < queryArr.length; i++) {
                        const keyValue = queryArr[i].split("=");
                        query[keyValue[0]] = keyValue[1];
                      }
                      router.replace({ path: redirectUrl, query });
                    } else if (!purchaseSwitch.value) {
                      router.replace({ path: "/account/course" });
                      // 当redirectUrl 有值 并且 redirectUrl不等于 undefined
                    } else if (redirectUrl && redirectUrl != "undefined") {
                      router.replace({ path: redirectUrl });
                    } else {
                      router.replace({ path: "/account/course" });
                    }
                  } else {
                    router.replace({ path: "/" });
                  }
                }
              }
          })
          .catch((err) => {
            // 密码错误等：关闭可能残留的实人弹窗，避免无凭证刷脸绕过
            try {
              realPersonDialogVisible.value = false;
              pendingLoginResp.value = null;
              faceLoginMode.value = false;
            } catch (e) {}
            if (err.code === 999) {
              errorNum.value += 1;
              setStore("errorNum", errorNum.value);
              if (errorNum.value >= 2 || imgVerification.token) {
                // 获取图形验证码
                getImgVerification();
              }
            } else if (err.code === 321) {
              getImgVerification();
            }
          });
      } else {
        pwdLoginByIdCard.value = false;
        if (imgVerification.token) {
          data.imageVerificationToken = imgVerification.token;
          data.imageVerification = pwdForm.imageVerification;
        }
        userLoginCode({
          clientType: 1,
          ...pwdForm,
          ...data,
        })
          .then(async (res) => {
            if (!res) return;
            errorNum.value = 0;
            setStore("errorNum", errorNum.value);

            if (res.needRealPersonVerify === true || res.needRealPersonVerify === "true") {
              await openRealPersonDialog(res, res.realNameVerifyStatus === 1);
              return;
            }

            if (!res.token) return;
            setToken(res.token);

              // 保存归档状态（先保存，再判断，避免时序问题）
              const currentArchiveStatus =
                res.archiveStatus !== undefined ? res.archiveStatus : null;
              console.log(
                "🔵 登录 - 保存归档状态到 localStorage:",
                currentArchiveStatus,
                `(${typeof currentArchiveStatus})`
              );
              setStore("archiveStatus", currentArchiveStatus); // 保存到 localStorage（持久化）
              setSession("archiveStatus", currentArchiveStatus); // 同时保存到 sessionStorage 保持兼容
              // 验证是否保存成功
              const savedValue = getStore("archiveStatus");
              console.log(
                "🔵 登录 - 验证 localStorage 保存结果:",
                savedValue,
                savedValue ? `(已保存)` : `(保存失败或为null)`
              );

              const userInfo = await getUserView();
              if (userInfo) {
                // 优先使用接口返回的 archiveStatus（最可靠），避免从 sessionStorage 读取时可能存在的时序问题
                // 如果接口返回了值，就用接口的值；如果接口没返回，才从 sessionStorage 读取
                let finalArchiveStatus = currentArchiveStatus;
                if (
                  finalArchiveStatus === null ||
                  finalArchiveStatus === undefined
                ) {
                  const archiveStatusFromStorage = getSession("archiveStatus");
                  // 统一解析：处理布尔值和字符串
                  if (
                    archiveStatusFromStorage === true ||
                    archiveStatusFromStorage === "true"
                  ) {
                    finalArchiveStatus = true;
                  } else if (
                    archiveStatusFromStorage === false ||
                    archiveStatusFromStorage === "false"
                  ) {
                    finalArchiveStatus = false;
                  } else {
                    finalArchiveStatus = null;
                  }
                }

                // 只有明确未归档（false）或未设置（null）时才跳转，已归档（true）不跳转
                if (
                  shopData.value.enabledBranchShop == true &&
                  shopData.value.contractExist == true &&
                  !userInfo.isReadContract &&
                  finalArchiveStatus !== true
                ) {
                  router.replace({ path: "/contract" });
                } else {
                  if (
                    route.query.redirect ||
                    window.location.hostname == "hnkdtdxlkspx.ykumda.com" ||
                    window.location.hostname == "hnkdtdxlkcxx.ykumda.com"
                  ) {
                    let redirectUrl = decodeURIComponent(route.query.redirect);
                    if (redirectUrl.indexOf("?") !== -1) {
                      const redirectUrlArr = redirectUrl.split("?");
                      redirectUrl = redirectUrlArr[0];
                      const query = {};
                      const queryArr = redirectUrlArr[1].split("&");
                      for (let i = 0; i < queryArr.length; i++) {
                        const keyValue = queryArr[i].split("=");
                        query[keyValue[0]] = keyValue[1];
                      }
                      router.replace({ path: redirectUrl, query });
                    } else if (!purchaseSwitch.value) {
                      router.replace({ path: "/account/course" });
                    } else if (redirectUrl && redirectUrl != "undefined") {
                      router.replace({ path: redirectUrl });
                    } else {
                      router.replace({ path: "/account/course" });
                    }
                  } else if (!purchaseSwitch.value) {
                    router.replace({ path: "/account/course" });
                  } else {
                    router.push({ path: "/" });
                  }
                }
              }
          })
          .catch((err) => {
            if (err.code === 999) {
              errorNum.value += 1;
              setStore("errorNum", errorNum.value);
              if (errorNum.value >= 2 || imgVerification.token) {
                // 获取图形验证码
                getImgVerification();
              }
            } else if (err.code === 321) {
              getImgVerification();
            }
          });
      }
    } else {
      return false;
    }
  });
};
const getImgVerification = () => {
  getImageVerification().then((res) => {
    if (res && res.token) {
      imgVerification.img = res.img;
      imgVerification.token = res.token;
    }
  });
};


// 管理端获取图形验证码
const getAdminImgVerification = () => {
  getCodeImg().then((res) => {
    if (res && res.token) {
      adminImgVerification.img = res.img
      adminImgVerification.token = res.token
    }
  })
}
/** 登录成功后的跳转逻辑（实人认证完成后调用） */
async function handleLoginSuccess(res) {
  if (!res || !res.token) return;
  setToken(res.token);
  const userInfo = await getUserView();
  if (userInfo) {
    if (
      shopData.value.enabledBranchShop == true &&
      shopData.value.contractExist == true &&
      !userInfo.isReadContract
    ) {
      router.replace({ path: "/contract" });
    } else {
      if (route.query.redirect) {
        router.replace({ path: decodeURIComponent(route.query.redirect) });
      } else if (!purchaseSwitch.value) {
        router.replace({ path: "/account/course" });
      } else {
        router.replace({ path: "/" });
      }
    }
  }
}


const getAdminCode = async () => {
  if (adminDisabled.value) return
  const phone = String(adminForm.phone).trim()
  if (!/^1\d{10}$/.test(phone)) {
    ElMessage.error("请输入正确的11位手机号")
    return
  }
  try {
    await adminSendCode({
      telCode: adminForm.telCode,
      phone: adminForm.phone,
      verificationCodeType: 2
    })
    adminDisabled.value = true
    adminTxt.value = "60s"
    let num = 60
    const timer = setInterval(() => {
      num--
      if (num <= 0) {
        clearInterval(timer)
        adminDisabled.value = false
        adminTxt.value = "获取验证码"
      } else {
        adminTxt.value = num + "s"
      }
    }, 1000)
  } catch (err) {
    ElMessage.error(err.msg || "验证码发送失败")
  }
}

const submitAdminLogin = () => {
  const formEl = adminTabName.value === "pwd" ? adminPwdFormRef.value : adminCodeFormRef.value
  if (!formEl) return

  formEl.validate((valid) => {
    if (!valid) return

    const params = {
      clientType: 1,
      phone: adminForm.phone,
      telCode: adminForm.telCode,
      country: "中国",
      os: getOsInfo().name,
      osVersion: getOsInfo().version,
      browser: getBrowserInfo().name,
      browserVersion: getBrowserInfo().version
    }

    // 管理端密码登录：如果已触发图形验证码，带上校验信息
    if (adminImgVerification.token && adminForm.adminImageVerification) {
      params.imageVerificationToken = adminImgVerification.token
      params.imageVerification = adminForm.adminImageVerification
    }

    if (adminTabName.value === "pwd") {
      let encryptedPassword = adminForm.loginPwd
      if (encrypt.value && adminForm.loginPwd) {
        const encrypted = encrypt.value.encrypt(adminForm.loginPwd)
        if (encrypted) encryptedPassword = encrypted
      }
      params.loginPwd = encryptedPassword

      adminLoginPwd(params).then((res) => {
        adminErrorNum.value = 0
        setStore("adminErrorNum", adminErrorNum.value)
        handleAdminLoginSuccess(res)
      }).catch((err) => {
        // 错误次数 + 验证码触发逻辑
        if (err.code === 999) {
          adminErrorNum.value += 1
          setStore("adminErrorNum", adminErrorNum.value)
          if (adminErrorNum.value >= 2 || adminImgVerification.token) {
            getAdminImgVerification()
          }
        } else if (err.code === 321) {
          getAdminImgVerification()
        }
        ElMessage.error(err.msg || "登录失败")
      })
    } else {
      params.verificationCode = adminForm.verificationCode

      adminLoginCode(params).then((res) => {
        adminErrorNum.value = 0
        setStore("adminErrorNum", adminErrorNum.value)
        handleAdminLoginSuccess(res)
      }).catch((err) => {
        // 错误次数 + 验证码触发逻辑
        if (err.code == 999) {
          adminErrorNum.value += 1
          setStore("adminErrorNum", adminErrorNum.value)
          if (adminErrorNum.value >= 2 || adminImgVerification.token) {
            getAdminImgVerification()
          }
        } else if (err.code == 321) {
          getAdminImgVerification()
        }
        ElMessage.error(err.msg || "登录失败")
      })
    }
  })
}

const handleAdminLoginSuccess = async (res) => {
  if (!res || !res.token) {
    ElMessage.error("登录失败，未获取到token")
    return
  }

  // 根据当前域名决定管理端 base URL
  const adminBaseUrl = resolveAdminBaseUrl()

  if (!adminBaseUrl) {
    ElMessage.warning("当前域名不支持管理员登录")
    return
  }

  // 1. 记住账号（可选，key 和管理端保持一致）
  if (adminForm && adminForm.remember) {
    localStorage.setItem("accountName", adminForm.phone)
  } else if (adminForm) {
    localStorage.removeItem("accountName")
  }

  // 2. 写入管理端 Token
  Cookies.set("EDU_ADMIN_TOKEN", res.token, { expires: 1 })

  // 3. 清除学员端登录态
  store.removeToken()
  setSession("userInfo", "")
  setSession("shopInfo", "")

  try {
    // 4. 获取管理员企业列表
    const shopList = await adminGetUserEnterpriseList()

    if (!shopList || shopList.length === 0) {
      ElMessage.error("当前管理员账号没有可用企业")
      return
    }

    if (shopList.length === 1) {
      // 只有一个企业，自动选择
      const shopRes = await adminChooseEnterprise({
        sid: shopList[0].id,
        os: getOsInfo().name,
        osVersion: getOsInfo().version,
        browser: getBrowserInfo().name,
        browserVersion: getBrowserInfo().version
      })
      localStorage.setItem("shopManager", JSON.stringify(shopRes))
      Cookies.set("EDU_ADMIN_SHOP", JSON.stringify(shopRes), { expires: 1 })
      console.log('shopRes内容：' + JSON.stringify(shopRes))

      // 5. 跳管理端首页
      window.location.href = adminBaseUrl + "/admin/dashboard/index"
    } else {
      // 多个企业，跳选择页
      window.location.href = adminBaseUrl + "/admin/company"
    }
  } catch (err) {
    console.error("获取或选择企业失败", err)
    // 失败时去企业选择页
    window.location.href = adminBaseUrl + "/admin/company"
  }
}
</script>
<style lang="scss">
.icon-comment {
  position: relative;
  left: -1px;
  top: 1px;
}

.page-login {
  .inner_tabs {
    .el-tabs__item {
      font-size: 16px;
      font-weight: 700;
    }

    .el-tabs__nav-wrap::after {
      background-color: #fff;
    }

    .el-tabs__active-bar {
      width: 10px !important;
      height: 3px;
      border-radius: 2px;
      left: 27px;
    }
  }

  .el-select {
    width: 100%;

    .el-input__inner {
      text-align: right;
    }
  }

  .el-input__icon {
    color: #333;
  }
}
</style>
<style lang="scss" scoped>
.page-login {
  height: calc(100vh - 66px - 70px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 60px;
  position: relative;

  .cas_transit_mask {
    position: absolute;
    inset: 0;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    margin-left: -60px;
    width: calc(100% + 60px);
  }

  .cas_transit_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 36px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  }

  .cas_transit_spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e5e7eb;
    border-top-color: #409eff;
    border-radius: 50%;
    animation: cas_transit_spin 0.8s linear infinite;
  }

  .cas_transit_text {
    margin: 16px 0 0;
    font-size: 15px;
    color: #606266;
    line-height: 1.5;
  }

  .page-login-main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form_box {
    min-height: 230px;
  }

  .demo-pwdForm {
    min-height: 120px;
  }

  .form_container {
    width: 440px;
    min-height: 510px;
    border-radius: 10px;
    background: #fff;
    padding: 30px;
    padding-top: 20px;
    position: relative;

    .title {
      font-size: 16px;
      font-weight: 700;
    }

    .drcode {
      text-align: center;

      img {
        margin: auto;
      }

      .desc {
        margin-top: 20px;

        b {
          color: #2256f6;
        }
      }
    }

    span {
      color: #333;
    }

    .login_plat {
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;

      a {
        margin-left: 5px;
      }
    }

    .btn {
      font-size: 14px !important;
    }

    .blue {
      color: #2256f6 !important;
    }

    .register_btn {
      text-align: center;
      margin-top: 20px;
    }

    .remember_checkbox {
      :deep(.el-checkbox__label) {
        font-size: 14px;
      }
    }

    .img_verification {
      display: flex;
      align-items: center;
      :deep(.el-input) {
        flex: 1;
      }

      img {
        width: 140px;
        height: 40px;
        cursor: pointer;
        margin-left: 20px;
      }
    }

    .submit {
      width: 100%;
      height: 50px;
      margin-top: 20px;
      font-size: 16px;
    }

    .cas_login_box {
      margin-bottom: 16px;
      text-align: center;

      .cas_login_tip {
        margin: 0 0 12px;
        padding: 10px 12px;
        text-align: left;
        font-size: 13px;
        line-height: 1.55;
        color: #b45309;
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: 6px;
      }

      .cas_login_btn {
        width: 100%;
        height: 46px;
        font-size: 16px;
      }

      .cas_login_split {
        margin-top: 14px;
        color: #909399;
        font-size: 13px;
      }
    }

    .face-login-pane {
      .face-login-status {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 8px;
      }

      .face-login-status--ok {
        color: #67c23a;
      }

      .face-login-status--pending {
        color: #909399;
      }

      .face-login-account {
        margin-bottom: 8px;
      }

      .face-login-account-form {
        :deep(.el-form-item) {
          margin-bottom: 0;
        }

        :deep(.el-form-item__label) {
          font-size: 14px;
          color: #333;
        }
      }

      .face-login-hint {
        margin: 8px 0 0;
        font-size: 12px;
        line-height: 1.5;
        color: #909399;
      }

      .face-login-submit {
        margin-top: 28px;
      }
    }

    .other_login {
      position: relative;
      left: auto;
      bottom: auto;
      margin-top: 16px;
      width: 100%;
      text-align: center;

      .icon_list {
        margin-top: 10px;
        display: flex;
        justify-content: center;

        img {
          // height: 30px;
          // width: 30px;
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
  }

  // 只在目标域名的新布局下生效
  .form_container.admin-login-layout {
    min-height: 550px;
    display: flex;
    flex-direction: column;

    .submit {
      margin-top: 20px;
    }

    .other_login_new {
      position: relative;
      left: auto;
      bottom: auto;
      margin-top: 16px;
      width: 100%;
      text-align: center;

      .icon_list {
        margin-top: 10px;
        display: flex;
        justify-content: center;

        img {
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .outer-tabs {
      flex: 1;
      display: flex;
      flex-direction: column;

      :deep(> .el-tabs__header) {
        flex: none;
        margin: 0 0 20px 0;
      }

      :deep(> .el-tabs__content) {
        flex: 1;
      }
      :deep(> .el-tabs__header .el-tabs__nav-wrap) {
        background: #F2F5FA;
        border-radius: 8px;
        padding: 4px;
      }

      :deep(> .el-tabs__header .el-tabs__nav) {
        float: none;
        display: flex;
        width: 100%;
        border-radius: 8px;
      }

      :deep(> .el-tabs__header .el-tabs__item) {
        flex: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0;
        border-radius: 8px;
        color: #69758A;
        font-size: 15px;
        font-weight: 700;
        transition: all 0.3s;

        &.is-active {
          background: #fff;
          color: #287FF2;
          font-weight: 600;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        &:hover {
          color: #287FF2;
        }
      }

      // 隐藏下划线 active bar
      :deep(> .el-tabs__header .el-tabs__active-bar) {
        display: none;
      }

      // 移除底部横线
      :deep(> .el-tabs__header .el-tabs__nav-wrap::after) {
        display: none;
      }
    }

    .admin-form {
      margin-top: 20px;
      min-height: 250px;
      .sort_btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 14px;
      }

      .submit {
        width: 100%;
        height: 50px;
        margin-top: 20px;
        font-size: 16px;
      }
    }
  }

}

.pwdForm {
  min-height: 316px;
  margin-top: 20px;
}

.blue_text {
  color: #2256f6 !important;
}

.qr_code {
  margin: 0 auto;
}

.tab_wrapper {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;

  .login_tips {
    position: relative;
    left: 4px;
    padding: 4px 8px;
    color: var(--el-color-primary);
    font-size: 13px;
    line-height: 17px;
    background: #fff;
    border: 1px solid rgba(34, 86, 246, 0.3);
    border-radius: 6px;

    &::after {
      content: "";
      position: absolute;
      right: -11px;
      top: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
      width: 10px;
      height: 10px;
      border: 1px solid rgba(34, 86, 246, 0.3);
      border-left: none;
      border-bottom: none;
      background: #fff;
    }
  }
}

.qr_code_iframe {
  width: 100%;
  height: 400px;
}

//修改选中后文本的颜色
:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #333 !important;
}

.hnkjspx {
  width: auto;
  margin: auto;
}
:deep(.el-input__wrapper) {
  position: relative;
}
:deep(.el-input__suffix .el-button) {
  position: absolute;
  right: 0;
}

// 实人认证弹窗样式
:deep(.realperson-dialog) {
  .el-dialog__header {
    padding: 24px 32px 8px;
  }
  .el-dialog__title {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
  .el-dialog__body {
    padding: 12px 32px 32px;
  }
}
.realperson-dialog-content {
  text-align: center;
  padding: 4px 0 0;
}
.idcard-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 16px 0 8px;
  box-sizing: border-box;
}
.upload-lead {
  margin: 0 auto;
  font-size: 13px;
  color: #909399;
  letter-spacing: 0.3px;
  line-height: 1.5;
  text-align: center;
  width: 100%;
}
.upload-row {
  display: flex;
  justify-content: center;
  gap: 24px;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 12px 28px 16px;
}
.upload-section {
  flex: 0 1 240px;
  width: 240px;
  max-width: calc(50% - 12px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.upload-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  width: 100%;
  text-align: center;
}
.upload-step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.idcard-uploader {
  width: 100%;
}
.idcard-uploader :deep(.el-upload) {
  border: 1.5px dashed #c0d8f7;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
  width: 100%;
  height: 172px;
  box-sizing: border-box;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f7fbff 0%, #f3f8fd 100%);
}
.idcard-uploader :deep(.el-upload:hover) {
  border-color: #409eff;
  background: #f0f7ff;
  box-shadow: 0 6px 18px rgba(64, 158, 255, 0.12);
}
.idcard-uploader.is-ready :deep(.el-upload) {
  border-style: solid;
  border-color: #95d475;
  background: #fff;
  padding: 10px;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #409eff;
  font-size: 14px;
  padding: 8px;
}
.upload-plus {
  font-size: 28px;
}
.idcard-preview {
  width: 100%;
  height: 100%;
  max-height: 148px;
  object-fit: contain;
  display: block;
  background: #fff;
  border-radius: 6px;
}
.ocr-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #409eff;
  font-size: 14px;
  padding: 4px 0;
}
.ocr-result {
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 6px;
  padding: 12px 20px;
  font-size: 14px;
  color: #333;
  line-height: 1.8;
  text-align: left;
  min-width: 280px;
}
.ocr-result p {
  margin: 0;
}

/* OCR 结果确认界面样式 */
.ocr-confirm-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: 100%;
  margin-top: 8px;
  padding: 24px 28px 8px;
  border-top: 1px solid #eef0f3;
  box-sizing: border-box;
}
.ocr-confirm-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin-bottom: 2px;
}
.ocr-form {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 16px;
  box-sizing: border-box;
}
.ocr-form .form-item {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  text-align: left;
}
.ocr-form .form-item--half {
  grid-column: span 1;
}
.ocr-form .form-item label {
  min-width: auto;
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  text-align: left;
  line-height: 1.2;
  padding-left: 2px;
}
.ocr-form .form-item :deep(.el-input) {
  flex: 1;
  width: 100%;
  --el-input-border-radius: 10px;
  --el-input-bg-color: #f7fbff;
  --el-input-border-color: #d6e6f7;
  --el-input-hover-border-color: #409eff;
  --el-input-focus-border-color: #409eff;
  --el-input-placeholder-color: #c0c4cc;
}
.ocr-form .form-item :deep(.el-input__wrapper) {
  min-height: 42px;
  padding: 4px 14px;
  border-radius: 10px;
  background: #f7fbff;
  box-shadow: 0 0 0 1px #d6e6f7 inset;
  transition: box-shadow 0.2s, background 0.2s;
}
.ocr-form .form-item :deep(.el-input__wrapper:hover) {
  background: #fff;
  box-shadow: 0 0 0 1px #409eff inset;
}
.ocr-form .form-item :deep(.el-input__wrapper.is-focus) {
  background: #fff;
  box-shadow: 0 0 0 1px #409eff inset, 0 0 0 3px rgba(64, 158, 255, 0.12);
}
.ocr-form .form-item :deep(.el-input__inner) {
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  color: #303133;
}
.ocr-confirm-tip {
  font-size: 13px;
  color: #a8abb2;
  text-align: center;
  margin-top: 2px;
}
.ocr-confirm-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 4px;
  padding-bottom: 2px;
}
.ocr-confirm-actions :deep(.el-button) {
  min-width: 120px;
  border-radius: 10px;
}

.qr-code-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
}
.qr-loading {
  width: 240px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background: #f5f7fa;
  border-radius: 8px;
}
.qr-expired-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p { color: #999; margin-bottom: 12px; }
}
.qr-tip { font-size: 14px; color: #666; margin: 10px 0; }
.login-viapi-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.login-viapi-video,
.login-viapi-img {
  width: 280px;
  height: 280px;
  border-radius: 50%;
  object-fit: cover;
  background: #111;
  transform: scaleX(-1);
}
.login-viapi-actions {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  justify-content: center;
}
.login-viapi-soft-tip {
  margin-top: 12px;
  font-size: 13px;
  color: #999;
  text-align: center;
  line-height: 1.5;
}
.login-viapi-no-cam {
  width: 100%;
  max-width: 420px;
  margin: 8px auto 0;
  padding: 16px 18px;
  background: #fff8f0;
  border: 1px solid #f5dab1;
  border-radius: 8px;
  text-align: left;
  box-sizing: border-box;
}
.login-viapi-no-cam-title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 600;
  color: #e6a23c;
  text-align: center;
}
.login-viapi-no-cam-list {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  color: #666;
  line-height: 1.7;
}
.login-viapi-no-cam-list li + li {
  margin-top: 4px;
}
.login-viapi-no-cam .login-viapi-actions {
  margin-top: 14px;
}
.verify-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  margin-top: 10px;
}
.verify-pending { color: #e6a23c; }
.verify-success { color: #67c23a; }
.verify-fail {
  color: #f56c6c;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 8px 12px 4px;
}
.verify-fail .fail-main {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  max-width: 520px;
  line-height: 1.5;
  text-align: left;
}
.verify-fail .fail-icon {
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 18px;
}
.verify-fail .fail-text {
  flex: 1;
}
.verify-fail .fail-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

@keyframes cas_transit_spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
<style>
.tel-code-popper.el-popper {
  height: 200px !important;
}
</style>
